(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mp-product-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mpcc-sticky-bar')) {
    class MpccStickyBar extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        this._setupVisibility();
        this._setupScroll();
      }

      disconnectedCallback() {
        if (this._io) this._io.disconnect();
      }

      _setupVisibility() {
        /* Always-visible mode ships with .is-visible server-side — no JS
           involved. This only runs for the scroll-trigger option. */
        const sel = this.dataset.trigger;
        if (!sel) return;
        let target = null;
        try {
          target = document.querySelector(sel);
        } catch (e) {
          target = null;
        }
        /* Honest fallback: unfindable trigger -> just show the bar */
        if (!target || !('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }
        this._io = new IntersectionObserver((entries) => {
          const entry = entries[0];
          const passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          this.classList.toggle('is-visible', passed);
        });
        this._io.observe(target);
      }

      _setupScroll() {
        const sel = this.dataset.scrollTarget;
        if (!sel) return;
        this.addEventListener('click', (event) => {
          const trigger = event.target.closest('.mpcc-sb__btn');
          if (!trigger || trigger.disabled) return;
          let target = null;
          try {
            target = document.querySelector(sel);
          } catch (e) {
            return;
          }
          if (!target) return;
          event.preventDefault();
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        });
      }
    }
    customElements.define('mpcc-sticky-bar', MpccStickyBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mpcc-benefits"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mpcc-benefit-slider')) {
  class MpccBenefitSlider extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('.mpcc-bc__cards');
      this.prevBtn = this.querySelector('[data-mpcc-bc-prev]');
      this.nextBtn = this.querySelector('[data-mpcc-bc-next]');
      if (!this.scroller) return;

      this.onScroll = this.update.bind(this);
      this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));

      this.ro = new ResizeObserver(() => this.update());
      this.ro.observe(this.scroller);
      this.update();
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      if (this.scroller) this.scroller.removeEventListener('scroll', this.onScroll);
    }

    stepSize() {
      const cards = this.scroller.querySelectorAll('.mpcc-bc__card');
      if (cards.length > 1) return cards[1].offsetLeft - cards[0].offsetLeft;
      return cards.length ? cards[0].offsetWidth : this.scroller.clientWidth;
    }

    step(dir) {
      const el = this.scroller;
      const size = this.stepSize();
      // Target an exact card snap position: a smooth scrollBy delta can fight
      // mandatory snap; scrollTo(card index * step) always lands on a card.
      const target = (Math.round(el.scrollLeft / size) + dir) * size;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      el.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });
    }

    update() {
      const el = this.scroller;
      const max = el.scrollWidth - el.clientWidth;
      this.toggleAttribute('data-static', max <= 1);
      if (this.prevBtn) this.prevBtn.disabled = el.scrollLeft <= 1;
      if (this.nextBtn) this.nextBtn.disabled = el.scrollLeft >= max - 1;
    }
  }
  customElements.define('mpcc-benefit-slider', MpccBenefitSlider);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mpcc-cart-drawer"] && !Shopify.designMode) return;
  try {
    
/* MPCC build C-5 (C-4 + M-15: price-derived gift detection, gift qty guard, copy sync — post AOV.ai acceptance) */

/* ================================================================
   AOV WIDGET — pure pipeline module (ruling spec:
   docs/spec-cart-widget-v1.3.0.md, register M-01..M-12; content:
   MP_AOV_Implementation_Pack/03 + 04). cart -> combo -> case ->
   ladder rung + gift tiles + template array -> tile states. Pure
   function of (cart, catalog, artifacts); rendering merely displays
   its output. Exposed as window.MPCC for the harness.
   ================================================================ */
(function () {
  'use strict';

  /* ============================================================
     CONFIG ARTIFACTS (R-31/M-05) — Zenith-owned CONTENT. Edit freely
     between these markers; never edit logic below END CONFIG.
     Colors match case-insensitively against store option values.
     Source of truth: 03_MP_AOV_Cart_Execution_Document.md (§4);
     machine form 04_case_table_machine.json. Regenerate from 03,
     never hand-fork.
     ============================================================ */

  /* Artifact 1a (M-06) — per-category bucket maps. Digit = largest
     listed value <= paid unit count, else 0. AG-08: never distinguish
     quantities beyond THESE buckets anywhere in logic. */
  var MPCC_BUCKETS = {
    pants: [1, 2, 3, 4],   /* 0 / 1 / 2 / 3 / 4+ */
    tee:   [1, 2, 4],      /* 0 / 1 / 2-3 / 4+  */
    boxer: [1]             /* 0 / 1+            */
  };

  /* Artifact 1b (M-06) — combo -> case map, TOTAL over the 5x4x2
     space. Key 'p-t-b'; '*' = any boxer digit. Exact key wins over
     wildcard (only 0-0-0 vs 0-0-1 differ). */
  var MPCC_COMBO_TO_CASE = {
    '0-0-0': 'C01', '0-0-1': 'C02',
    '1-0-*': 'C03', '0-1-*': 'C04', '0-2-*': 'C05', '0-4-*': 'C06',
    '1-1-*': 'C07', '1-2-*': 'C08', '1-4-*': 'C09',
    '2-0-*': 'C10', '2-1-*': 'C11', '2-2-*': 'C12', '2-4-*': 'C13',
    '3-0-*': 'C14', '3-1-*': 'C15', '3-2-*': 'C16', '3-4-*': 'C17',
    '4-0-*': 'C18', '4-1-*': 'C19', '4-2-*': 'C20', '4-4-*': 'C21'
  };

  /* Artifact 1c (M-08) — the 21 production cases (pack 03 §4 / 04).
     Ladder rungs carry BOTH copy registers; MPCC_COPY picks. Every
     message <=45 chars incl. emoji (A-19; build-gated). Gift tiles
     are engine-prepended per the ladder — never authored here.
     M-13/M-14 (one gift max): every claim_both rung is VOID and has
     been removed; the choice/upgrade claim strings are code-owned
     UI fallbacks (MPCC_UI_STRINGS) pending the founder pass + pack
     03/04 regeneration. Affirms that celebrated a second gift were
     re-authored to the one-gift reality. */
  var MPCC_CASE_TABLE = [
    { id: 'C01', selector_label: 'SHOP NOW',
      template: [ { category: 'pants', tile_mode: 'single-color' }, { category: 'tee', tile_mode: 'all-colors', cap: 1 }, { category: 'boxer', tile_mode: 'single-color', cap: 1 } ],
      ladder: { push: { a: '👇 CHECK OUT OUR BEST-SELLING PANTS', b: 'THE PANTS DO THE WORK. START THERE.' } } },
    { id: 'C02', selector_label: 'SHOP NOW',
      template: [ { category: 'pants', tile_mode: 'single-color' }, { category: 'tee', tile_mode: 'all-colors', cap: 1 }, { category: 'boxer', tile_mode: 'single-color', cap: 1 } ],
      ladder: { push: { a: '👇 BEST-SELLING PANTS — $120, SHIPS FREE', b: 'YOU KNOW THE FABRIC. NOW THE PANTS.' } } },
    { id: 'C03', selector_label: 'SELECT SIZE',
      template: [ { category: 'pants', tile_mode: 'single-color', cap: 4 }, { category: 'tee', tile_mode: 'single-color', cap: 1 }, { category: 'pants', tile_mode: 'single-color' }, { category: 'boxer', tile_mode: 'single-color', cap: 1 } ],
      ladder: { claim_boxer: { a: '👇 ADD YOUR FREE BOXER!', b: 'YOUR FREE BOXER JUST UNLOCKED 👇' },
                push: { a: '👇 ADD A 2ND COLOR FOR $84 + FREE BOXER', b: "NEW COLOR, SAME FIT — $84. BOXER'S FREE." } } },
    { id: 'C04', selector_label: 'SHOP NOW',
      template: [ { category: 'tee', tile_mode: 'single-color' }, { category: 'pants', tile_mode: 'single-color', cap: 4 }, { category: 'boxer', tile_mode: 'single-color', cap: 1 } ],
      ladder: { push: { a: '👇 ADD A 2ND COLOR FOR $45 + FREE SHIPPING', b: "ONE TAP, $45 — AND SHIPPING'S FREE." } } },
    { id: 'C05', selector_label: 'SHOP NOW',
      template: [ { category: 'tee', tile_mode: 'single-color', cap: 2 }, { category: 'pants', tile_mode: 'single-color', cap: 4 }, { category: 'boxer', tile_mode: 'single-color', cap: 1 } ],
      ladder: { claim_boxer: { a: '👇 ADD YOUR FREE BOXER!', b: 'YOUR FREE BOXER JUST UNLOCKED 👇' },
                push: { a: '👇 GET THE PANTS — $120 + FREE BOXER', b: 'THE PANTS FINISH IT — FREE BOXER TOO.' } } },
    { id: 'C06', selector_label: 'SHOP NOW',
      template: [ { category: 'tee', tile_mode: 'single-color' }, { category: 'pants', tile_mode: 'single-color', cap: 5 } ],
      ladder: { claim_boxer: { a: '👇 ADD YOUR FREE BOXER!', b: 'GIFT №1 IS READY — FIRST TILE 👇' },
                push: { a: '👇 ADD PANTS $120 — FREE T-SHIRT WITH THEM', b: 'ONE PAIR OF PANTS = A FREE T-SHIRT.' } } },
    { id: 'C07', selector_label: 'SELECT SIZE',
      template: [ { category: 'pants', tile_mode: 'single-color' }, { category: 'tee', tile_mode: 'single-color' } ],
      ladder: { claim_boxer: { a: '👇 ADD YOUR FREE BOXER!', b: 'THAT COMBO EARNED YOU A FREE BOXER 👇' },
                push: { a: '👇 ADD A 2ND COLOR OF PANTS FOR ONLY $84', b: 'START THE ROTATION — 2ND PAIR, $84.' } } },
    { id: 'C08', selector_label: 'SELECT SIZE',
      template: [ { category: 'pants', tile_mode: 'single-color' }, { category: 'tee', tile_mode: 'single-color' } ],
      ladder: { claim_boxer: { a: '👇 ADD YOUR FREE BOXER!', b: "THE OUTFIT EARNED IT — BOXER'S FREE 👇" },
                push: { a: '👇 2ND PAIR FOR $84 — FREE T-SHIRT WITH IT', b: "$84 BUYS THE PAIR. THE T-SHIRT'S FREE." } } },
    { id: 'C09', selector_label: 'SELECT SIZE',
      template: [ { category: 'pants', tile_mode: 'single-color', cap: 4 } ],
      ladder: { affirm: { a: "👌 YOU'RE GETTING AN AMAZING DEAL!", b: "EVERYTHING'S UNLOCKED. CHECK OUT PROUD." } } },
    { id: 'C10', selector_label: 'SELECT SIZE',
      template: [ { category: 'pants', tile_mode: 'single-color', cap: 5 }, { category: 'tee', tile_mode: 'single-color', cap: 1 } ],
      ladder: { claim_boxer: { a: '👇 ADD YOUR FREE BOXER!', b: "TWO PAIRS IN — YOUR BOXER'S FREE 👇" },
                push: { a: '👇 ADD A 3RD COLOR $84 + FREE T-SHIRT', b: 'PAIR №3 → ALL $96 — AND A FREE T-SHIRT.' } } },
    { id: 'C11', selector_label: 'SELECT SIZE',
      template: [ { category: 'tee', tile_mode: 'single-color' }, { category: 'pants', tile_mode: 'single-color', cap: 3 }, { category: 'boxer', tile_mode: 'single-color', cap: 1 } ],
      ladder: { claim_boxer: { a: '👇 ADD YOUR FREE BOXER!', b: "BOXER FIRST — IT'S FREE, IT'S WAITING 👇" },
                push: { a: '👇 ADD A TEE FOR $45 + FREE T-SHIRT', b: '$11 TO A FREE T-SHIRT — ANY TILE WINS.' } } },
    { id: 'C12', selector_label: 'SELECT SIZE',
      template: [ { category: 'pants', tile_mode: 'single-color', cap: 4 }, { category: 'tee', tile_mode: 'single-color' } ],
      ladder: { affirm: { a: "👌 YOU'RE GETTING AN AMAZING DEAL!", b: 'THIS IS THE CART WE BUILT THE STORE FOR.' } } },
    { id: 'C13', selector_label: 'SELECT SIZE',
      template: [ { category: 'pants', tile_mode: 'single-color', cap: 4 } ],
      ladder: { affirm: { a: "👌 YOU'RE GETTING AN AMAZING DEAL!", b: 'THIS IS THE CART WE BUILT THE STORE FOR.' } } },
    { id: 'C14', selector_label: 'SELECT SIZE',
      template: [ { category: 'pants', tile_mode: 'single-color', cap: 3 }, { category: 'tee', tile_mode: 'single-color', cap: 1 } ],
      ladder: { affirm: { a: "👌 YOU'RE GETTING AN AMAZING DEAL!", b: 'FIVE PIECES, GIFT IN HAND, $96 A PAIR.' } } },
    { id: 'C15', selector_label: 'SELECT SIZE',
      template: [ { category: 'pants', tile_mode: 'single-color', cap: 3 }, { category: 'tee', tile_mode: 'single-color' } ],
      ladder: { affirm: { a: "👌 YOU'RE GETTING AN AMAZING DEAL!", b: 'FULL ROTATION, PLUS A GIFT. WELL PLAYED.' } } },
    { id: 'C16', selector_label: 'SELECT SIZE',
      template: [ { category: 'pants', tile_mode: 'single-color', cap: 3 }, { category: 'tee', tile_mode: 'single-color' } ],
      ladder: { affirm: { a: "👌 YOU'RE GETTING AN AMAZING DEAL!", b: 'THIS IS THE CART WE BUILT THE STORE FOR.' } } },
    { id: 'C17', selector_label: 'SELECT SIZE',
      template: [ { category: 'pants', tile_mode: 'single-color', cap: 3 } ],
      ladder: { affirm: { a: "👌 YOU'RE GETTING AN AMAZING DEAL!", b: 'THIS IS THE CART WE BUILT THE STORE FOR.' } } },
    { id: 'C18', selector_label: 'SELECT SIZE',
      template: [ { category: 'pants', tile_mode: 'single-color', cap: 3 }, { category: 'tee', tile_mode: 'single-color', cap: 1 } ],
      ladder: { affirm: { a: "👌 YOU'RE GETTING AN AMAZING DEAL!", b: 'FOUR PAIRS DEEP — THE GIFT IS ON US.' } } },
    { id: 'C19', selector_label: 'SELECT SIZE',
      template: [ { category: 'pants', tile_mode: 'single-color', cap: 3 }, { category: 'tee', tile_mode: 'single-color' } ],
      ladder: { affirm: { a: "👌 YOU'RE GETTING AN AMAZING DEAL!", b: 'THIS IS THE CART WE BUILT THE STORE FOR.' } } },
    { id: 'C20', selector_label: 'SELECT SIZE',
      template: [ { category: 'pants', tile_mode: 'single-color', cap: 3 }, { category: 'tee', tile_mode: 'single-color' } ],
      ladder: { affirm: { a: "👌 YOU'RE GETTING AN AMAZING DEAL!", b: 'THIS IS THE CART WE BUILT THE STORE FOR.' } } },
    { id: 'C21', selector_label: 'SELECT SIZE',
      template: [ { category: 'pants', tile_mode: 'single-color', cap: 3 } ],
      ladder: { affirm: { a: "👌 YOU'RE GETTING AN AMAZING DEAL!", b: 'THIS IS THE CART WE BUILT THE STORE FOR.' } } }
  ];

  /* Artifact 1d (M-07/M-09) — gift configuration. thresholdTier
     indexes the section's tier settings (single source with the
     progress bar, M-08): tier 2 = boxer, tier 3 = tee. handle '' =
     DEFERRED-BACKEND MODE (M-07.5): claims add the REGULAR product
     tagged with the _mpcc_gift line property; set the real $0 gift
     product handles here at launch — config-only switch. */
  var MPCC_GIFTS = {
    boxer: { name: 'BOXER',   category: 'boxer', thresholdTier: 2, handle: '' },
    tee:   { name: 'T-SHIRT', category: 'tee',   thresholdTier: 3, handle: '' }
  };

  /* Copy register selection (M-05): 'a' = proven old-cart grammar,
     'b' = new voice. Global default + per-rung overrides keyed
     '<caseId>.<rung>' (e.g. { 'C10.push': 'b' }). */
  var MPCC_COPY = { defaultRegister: 'a', overrides: {} };
  /* Artifact 2 (§11.2) — ranked color lists, most popular first.
     Restricted to the store's live color vocabulary (2026-07-21). */
  var MPCC_RANKED_COLORS = {
    pants: ['navy', 'black', 'gray', 'khaki', 'birch', 'blue', 'green'],
    tee:   ['black', 'navy', 'gray'],
    boxer: ['navy', 'black', 'gray']
  };

  /* Artifact 3 (§11.3) — pants (waist,length) -> boxer size PAIR
     mapping. Keys are pairKey() form: inch marks stripped, "W/L".
     A missing pair = derivation unavailable (NEVER interpolate).
     OBVIOUS PLACEHOLDER STUB — real table pending from Zenith. */
  var MPCC_BOXER_MAPPING = {
    '33/30': 'M', '34/30': 'M', '34/32': 'L', '36/32': 'L', '38/32': 'XL'
  };

  /* L-08 — boxer inseam style used when boxer sizing is DERIVED
     (the mapping outputs only a size). Revisit when the real
     mapping arrives; isolated here so nothing else changes. */
  var MPCC_DERIVED_BOXER_LENGTH = 'Mid 5"';

  /* Artifact 4 (§11.4 / AM-01) — the store adapter. Binds abstract
     categories to store products. An attribute lives either in a
     product OPTION or in PRODUCT IDENTITY (which product = which
     value; identityOption names the single-valued option that
     carries the value). The pipeline never touches Shopify shapes
     outside this adapter. */
  var MPCC_STORE_ADAPTER = {
    categories: {
      pants: {
        sizeAttributes: ['waist', 'length'],   /* pair-atomic, R-17 */
        attributes: {
          color:  { source: 'product', identityOption: 'Color' },
          waist:  { source: 'option', option: 'Waist' },
          length: { source: 'option', option: 'Length' }
        },
        products: ['tech-pants', 'tech-pants-1', 'tech-pants-2', 'tech-pants-3', 'tech-pants-4', 'tech-pants-5', 'tech-pants-6']
      },
      boxer: {
        sizeAttributes: ['length', 'size'],
        attributes: {
          color:  { source: 'option', option: 'Color' },
          length: { source: 'product', identityOption: 'Length' }, /* inseam style */
          size:   { source: 'option', option: 'Size' }
        },
        products: ['boxer-briefs', 'boxer-briefs-1', 'boxer-briefs-2']
      },
      tee: {
        sizeAttributes: ['size'],
        attributes: {
          color: { source: 'product', identityOption: 'Color' },
          size:  { source: 'option', option: 'Size' }
        },
        /* PENDING (§11.5): 'obsidian-tshirts-landing-ls1' is the only
           BLACK tee on the store despite the landing-page handle —
           confirm with Arda it is the canonical black tee product. */
        products: ['tshirt-1', 'tshirt-2', 'obsidian-tshirts-landing-ls1']
      }
    }
  };

  /* Widget-facing UI strings (chrome copy stays in section settings). */
  var MPCC_UI_STRINGS = {
    allColors: 'ALL COLORS',
    categoryNames: { pants: 'Pants', tee: 'Tee', boxer: 'Boxer' },
    addFailedOos: 'That size just sold out',
    addFailedGeneric: 'Something went wrong — try again',
    stockCapped: "That's all the stock we have for this one",
    /* M-07.4 honest loss toasts (thresholds quoted per the sync law;
       post-mutation past tense — code-owned copy pending founder pass) */
    giftLostBoxer: 'BELOW $180 — YOUR FREE BOXER WAS REMOVED',
    giftLostTee: 'BELOW $280 — YOUR FREE T-SHIRT WAS REMOVED',
    /* M-13.4/M-14 swap-on-claim: honest post-swap toast (the boxer
       gift line leaves when the tee gift is claimed) + the one-gift
       invariant repair toast (legacy two-gift carts). Code-owned. */
    giftSwapped: 'BOXER SWAPPED FOR YOUR FREE T-SHIRT',
    /* M-08 rule 1 is strict: while a gift pends, the banner NEVER shows
       push/affirm. When a case lacks the matching claim rung these
       fallbacks apply — code-owned pending founder pass (M-13.6).
       M-14: the choice line MUST read as either/or ("OR" — Arda
       2026-08-10); the upgrade line offers the swap, never a 2nd gift.
       All four are bar messages: the <=45-char law applies (gated). */
    claimBoxerFallback: '👇 ADD YOUR FREE BOXER!',
    claimTeeFallback: '👇 CLAIM YOUR FREE T-SHIRT!',
    claimChoiceFallback: '👇 PICK YOUR FREE GIFT — T-SHIRT OR BOXER',
    claimUpgradeFallback: '👇 SWAP YOUR BOXER FOR A FREE T-SHIRT'
  };

  /* R-30 / M-03e / M-09 — rule-level constants, NOT content: paid
     instant-add tiles read the instant-add label; gift tiles read
     the claim label in both interaction states. Selector-state
     labels on paid tiles come from the active case's selector_label. */
  var MPCC_INSTANT_ADD_LABEL = 'ADD MY SIZE';
  var MPCC_CLAIM_LABEL = 'CLAIM FREE';

  /* ================== END CONFIG ARTIFACTS =================== */

  var CATEGORIES = ['pants', 'tee', 'boxer']; /* R-02: fixed; combo digit order P-T-B (R-06) */

  function norm(v) { return String(v == null ? '' : v).trim().toLowerCase(); }
  /* pairKey: '33"'/'30"' -> '33/30' (inch marks stripped) */
  function pairKey(waist, length) {
    var w = String(waist == null ? '' : waist).replace(/["″”]/g, '').trim();
    var l = String(length == null ? '' : length).replace(/["″”]/g, '').trim();
    return w + '/' + l;
  }

  /* ---------- load-time validation (M-06/M-08/M-11): fail loudly in dev ---------- */
  function messageLength(s) {
    /* code points, so emoji count as 1 (matches the pack's counts) */
    var n = 0;
    for (var i = 0; i < s.length; i++) {
      var code = s.charCodeAt(i);
      n++;
      if (code >= 0xD800 && code <= 0xDBFF) i++; /* surrogate pair */
    }
    return n;
  }
  function validateConfig(artifacts, catalog) {
    var v = [];
    var i, j, k;
    /* M-13/M-14: claim_both is retired vocabulary — its presence is a
       config error. claim_choice/claim_upgrade allow per-case authored
       copy once the founder pass lands; today the UI fallbacks serve. */
    var RUNGS = ['claim_choice', 'claim_upgrade', 'claim_boxer', 'claim_tee', 'push', 'affirm'];
    var byId = {};
    var cases = artifacts.caseTable || [];
    for (i = 0; i < cases.length; i++) {
      var cs = cases[i];
      if (byId[cs.id]) v.push('case ' + cs.id + ' duplicated');
      byId[cs.id] = cs;
      if (typeof cs.selector_label !== 'string') v.push('case ' + cs.id + ': selector_label missing');
      var tpl = cs.template || [];
      for (j = 0; j < tpl.length; j++) {
        var seg = tpl[j];
        if (CATEGORIES.indexOf(seg.category) < 0) v.push('case ' + cs.id + ' seg ' + j + ': bad category ' + seg.category);
        if (seg.tile_mode !== 'single-color' && seg.tile_mode !== 'all-colors') v.push('case ' + cs.id + ' seg ' + j + ': bad tile_mode ' + seg.tile_mode);
        if (seg.cap != null && (typeof seg.cap !== 'number' || seg.cap < 1 || seg.cap % 1 !== 0)) v.push('case ' + cs.id + ' seg ' + j + ': cap must be a positive integer');
      }
      var ladder = cs.ladder || {};
      var hasRung = false;
      for (k in ladder) {
        if (!Object.prototype.hasOwnProperty.call(ladder, k)) continue;
        if (RUNGS.indexOf(k) < 0) { v.push('case ' + cs.id + ': unknown rung ' + k); continue; }
        hasRung = true;
        var rung = ladder[k];
        var regs = ['a', 'b'];
        for (j = 0; j < regs.length; j++) {
          var txt = rung[regs[j]];
          if (txt == null) continue;
          var len = messageLength(String(txt));
          /* A-19 / message-length law: <=45 chars including emoji */
          if (len > 45) v.push('case ' + cs.id + ' ' + k + '.' + regs[j] + ': ' + len + ' chars > 45');
        }
        if (rung.a == null && rung.b == null) v.push('case ' + cs.id + ' ' + k + ': empty rung');
      }
      if (!hasRung) v.push('case ' + cs.id + ': ladder has no rungs');
    }
    /* combo map must be TOTAL over the 5x4x2 bucket space (M-06) */
    var PD = [0, 1, 2, 3, 4], TD = [0, 1, 2, 4], BD = [0, 1];
    for (i = 0; i < PD.length; i++) for (j = 0; j < TD.length; j++) for (k = 0; k < BD.length; k++) {
      var key = PD[i] + '-' + TD[j] + '-' + BD[k];
      var cid = artifacts.comboToCase[key] || artifacts.comboToCase[PD[i] + '-' + TD[j] + '-*'];
      if (!cid) v.push('combo ' + key + ' unmapped — combo_to_case must be total');
      else if (!byId[cid]) v.push('combo ' + key + ' -> ' + cid + ' but no such case');
    }
    for (i = 0; i < CATEGORIES.length; i++) {
      var cat = CATEGORIES[i];
      if (!artifacts.buckets[cat] || !artifacts.buckets[cat].length) v.push('buckets missing: ' + cat);
      if (!artifacts.rankedColors[cat] || !artifacts.rankedColors[cat].length) v.push('ranked list missing/empty: ' + cat);
      if (!artifacts.adapter.categories[cat]) v.push('adapter category missing: ' + cat);
    }
    for (k in artifacts.gifts) {
      if (!Object.prototype.hasOwnProperty.call(artifacts.gifts, k)) continue;
      var g = artifacts.gifts[k];
      if (CATEGORIES.indexOf(g.category) < 0) v.push('gift ' + k + ': bad category ' + g.category);
      if (g.thresholdTier !== 2 && g.thresholdTier !== 3) v.push('gift ' + k + ': thresholdTier must be 2 or 3');
      if (typeof g.name !== 'string' || !g.name) v.push('gift ' + k + ': name missing');
    }
    /* M-13.6/M-14 — the code-owned claim fallbacks are bar messages:
       the <=45-char law (A-19) covers them too */
    var FALLBACKS = ['claimBoxerFallback', 'claimTeeFallback', 'claimChoiceFallback', 'claimUpgradeFallback'];
    for (i = 0; i < FALLBACKS.length; i++) {
      var fs = artifacts.ui ? artifacts.ui[FALLBACKS[i]] : null;
      if (typeof fs !== 'string' || !fs) v.push('ui fallback missing: ' + FALLBACKS[i]);
      else if (messageLength(fs) > 45) v.push('ui fallback over 45 code points (' + messageLength(fs) + '): ' + FALLBACKS[i]);
    }
    var m = artifacts.boxerMapping || {};
    for (k in m) { if (Object.prototype.hasOwnProperty.call(m, k) && (!m[k] || typeof m[k] !== 'string')) v.push('mapping ' + k + ': empty output'); }
    if (catalog && catalog.products) {
      for (i = 0; i < CATEGORIES.length; i++) {
        var def = artifacts.adapter.categories[CATEGORIES[i]];
        if (!def) continue;
        for (j = 0; j < def.products.length; j++) {
          if (!catalog.products[def.products[j]]) v.push('adapter handle not in catalog island: ' + def.products[j]);
        }
      }
      /* M-07.5: a configured gift handle must also be in the island
         roster, or claims silently fall back to the regular product */
      for (k in artifacts.gifts) {
        if (!Object.prototype.hasOwnProperty.call(artifacts.gifts, k)) continue;
        if (artifacts.gifts[k].handle && !catalog.products[artifacts.gifts[k].handle]) {
          v.push('gift handle not in catalog island roster: ' + artifacts.gifts[k].handle);
        }
      }
    }
    return v;
  }

  /* ---------- adapter helpers (the ONLY Shopify-shape readers) ---------- */
  function optionIndex(product, optionName) {
    for (var i = 0; i < product.options.length; i++) {
      if (norm(product.options[i]) === norm(optionName)) return i;
    }
    return -1;
  }
  /* identity value of a product for an identity-sourced attribute:
     the single distinct value of its identityOption across variants */
  function identityValue(product, identityOption) {
    var idx = optionIndex(product, identityOption);
    if (idx < 0) return null;
    return product.variants.length ? product.variants[0][idx + 1] : null;
  }
  function attrOfLine(catDef, catalog, line, attrName) {
    var def = catDef.attributes[attrName];
    if (!def) return null;
    if (def.source === 'option') return line.options[def.option] != null ? line.options[def.option] : null;
    var product = catalog.products[line.handle];
    if (product) return identityValue(product, def.identityOption);
    /* handle not in the catalog island (e.g. a dedicated gift product,
       M-07): fall back to the line's own option value under the
       identity option's name */
    return line.options && line.options[def.identityOption] != null ? line.options[def.identityOption] : null;
  }

  /* gift-handle lookup: handle -> gift key ('' handles ignored) */
  function giftHandleSet(gifts) {
    var s = {};
    for (var k in gifts) {
      if (Object.prototype.hasOwnProperty.call(gifts, k) && gifts[k].handle) s[gifts[k].handle] = k;
    }
    return s;
  }

  /* abstract cart lines: [{category, color, sizeAttrs, quantity, gift, key}].
     Ghost/unknown handles don't map to a category and drop out. A line
     is a GIFT line iff it carries the _mpcc_gift property (island flag),
     or its handle is a configured gift handle (M-07.3), or — M-15 —
     it is a $0-priced tee/boxer line: the store's discount backend is
     the pricing authority (division-of-labor ruling), so an item it
     freed IS the claimed gift no matter which route added it (closes
     the product-page blind spot: no second offer beside an app-freed
     gift). Price-derivation is category-guarded — a hypothetical free
     PANTS line stays a paid line for counting. Gift lines are size
     signals and ownership (M-02) but never counts/eligibility. */
  function abstractLines(cart, catalog, adapter, gifts) {
    var out = [];
    var giftSet = giftHandleSet(gifts || {});
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var line = items[i];
      var category = null;
      for (var c = 0; c < CATEGORIES.length; c++) {
        if (adapter.categories[CATEGORIES[c]].products.indexOf(line.handle) >= 0) { category = CATEGORIES[c]; break; }
      }
      if (!category && giftSet[line.handle]) category = (gifts[giftSet[line.handle]] || {}).category || null;
      if (!category) continue;
      var catDef = adapter.categories[category];
      var sizeAttrs = {};
      for (var s = 0; s < catDef.sizeAttributes.length; s++) {
        var an = catDef.sizeAttributes[s];
        sizeAttrs[an] = attrOfLine(catDef, catalog, line, an);
      }
      out.push({
        category: category,
        color: attrOfLine(catDef, catalog, line, 'color'),
        sizeAttrs: sizeAttrs,
        quantity: line.quantity || 0,
        gift: !!line.gift || !!giftSet[line.handle] ||
              (line.price === 0 && (line.quantity || 0) > 0 && (category === 'tee' || category === 'boxer')),
        key: line.key || null
      });
    }
    return out;
  }

  /* ---------- the cart combo (M-06) ---------- */
  /* Digits count PAID units only (M-07.1) */
  function countUnits(lines) {
    var counts = { pants: 0, tee: 0, boxer: 0 };
    for (var i = 0; i < lines.length; i++) {
      if (lines[i].gift) continue;
      counts[lines[i].category] += lines[i].quantity;
    }
    return counts;
  }
  /* M-06 — the ONLY quantity flattening anywhere (AG-08): digit =
     largest configured bucket value <= n, else 0 */
  function bucket(n, category, buckets) {
    var list = (buckets && buckets[category]) || [];
    var digit = 0;
    for (var i = 0; i < list.length; i++) {
      if (n >= list[i]) digit = list[i];
    }
    return digit;
  }
  function comboOf(counts, buckets) {
    return bucket(counts.pants, 'pants', buckets) + '-' +
           bucket(counts.tee, 'tee', buckets) + '-' +
           bucket(counts.boxer, 'boxer', buckets);
  }
  /* exact key wins over the 'p-t-*' wildcard (04's combo_to_case rule) */
  function caseFor(combo, artifacts) {
    var id = artifacts.comboToCase[combo];
    if (!id) {
      var parts = combo.split('-');
      id = artifacts.comboToCase[parts[0] + '-' + parts[1] + '-*'];
    }
    if (!id) return null;
    for (var i = 0; i < artifacts.caseTable.length; i++) {
      if (artifacts.caseTable[i].id === id) return artifacts.caseTable[i];
    }
    return null; /* impossible when validateConfig passed */
  }

  /* ---------- M-07 paid subtotal + gift states ---------- */
  /* eligibility base: sum of non-gift final line prices, in cents */
  function paidSubtotal(cart, gifts) {
    var giftSet = giftHandleSet(gifts || {});
    var total = 0;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var line = items[i];
      if (line.gift || giftSet[line.handle]) continue;
      total += line.price || 0;
    }
    return total;
  }
  /* earned/claimed/pending per gift. Claimed = a gift line of that
     category is in the cart (pure derivation — M-02, never stored).
     M-13/M-14 — ONE gift maximum, offers as a CHOICE:
       · earned  = paid subtotal >= this gift's threshold (loss-guard
         truth: a CLAIMED gift stays valid while its own threshold
         holds — M-13.5; an unclaimed OFFER is a different thing).
       · pending = this gift is OFFERED right now. With NOTHING
         claimed: every earned gift pends — at >=$280 boxer AND tee
         pend together as an either/or choice (M-14; claiming one
         ends the other's offer via derivation). With the boxer
         claimed: only the tee can pend, as the UPGRADE offer
         (upgrade flag set; claiming swaps boxer -> tee, M-13.4).
         With the tee claimed: nothing pends (no downgrade offer). */
  function giftStates(paidCents, lines, tiersCents, gifts) {
    var out = {};
    var k, i;
    var claimedByKey = {}, anyClaimed = false;
    for (k in gifts) {
      if (!Object.prototype.hasOwnProperty.call(gifts, k)) continue;
      claimedByKey[k] = false;
      for (i = 0; i < lines.length; i++) {
        if (lines[i].gift && lines[i].category === gifts[k].category) { claimedByKey[k] = true; anyClaimed = true; break; }
      }
    }
    for (k in gifts) {
      if (!Object.prototype.hasOwnProperty.call(gifts, k)) continue;
      var g = gifts[k];
      var threshold = (tiersCents && tiersCents[g.thresholdTier - 1]) || 0;
      var claimed = claimedByKey[k];
      var earned = threshold > 0 && paidCents >= threshold;
      var upgrade = false;
      var pending;
      if (!anyClaimed) {
        pending = earned && !claimed;
      } else if (g.thresholdTier === 3 && !claimed && earned) {
        /* boxer claimed, tee threshold met -> tee pends as the swap
           offer; any other claimed state offers nothing */
        pending = true;
        upgrade = true;
      } else {
        pending = false;
      }
      out[k] = { earned: earned, claimed: claimed, pending: pending, upgrade: upgrade, thresholdCents: threshold };
    }
    return out;
  }

  /* ---------- M-08 the message ladder ---------- */
  function rungText(artifacts, caseRow, rungKey) {
    var rung = caseRow.ladder ? caseRow.ladder[rungKey] : null;
    if (!rung) return null;
    var copy = artifacts.copy || {};
    var reg = (copy.overrides && copy.overrides[caseRow.id + '.' + rungKey]) || copy.defaultRegister || 'a';
    var text = rung[reg];
    if (text == null) text = rung.a != null ? rung.a : rung.b;
    return text == null ? null : text;
  }
  /* M-08 strict: rung (1) claim while ANY gift pends — matching
     authored rung first, then the UI-string claim fallback;
     push/affirm are reachable ONLY with no pending gift (a push
     promising an already-earned gift, or an affirm beside an
     unclaimed one, is dishonest). M-13/M-14 one-gift chain:
       both pend (>=280, nothing claimed) -> claim_choice (either/or
         copy — must read as a pick-one, never "both");
       tee pends as upgrade (boxer claimed) -> claim_upgrade (swap);
       boxer pends alone ($180-279 unclaimed) -> claim_boxer;
       tee pends alone (defensive; unreachable while the boxer
         window opens below the tee window) -> claim_tee. */
  function selectRung(artifacts, caseRow, gs) {
    var t;
    if (gs.boxer.pending && gs.tee.pending) {
      if ((t = rungText(artifacts, caseRow, 'claim_choice')) != null) return { rung: 'claim_choice', message: t };
      return { rung: 'claim_choice', message: artifacts.ui.claimChoiceFallback };
    }
    if (gs.tee.pending && gs.tee.upgrade) {
      if ((t = rungText(artifacts, caseRow, 'claim_upgrade')) != null) return { rung: 'claim_upgrade', message: t };
      return { rung: 'claim_upgrade', message: artifacts.ui.claimUpgradeFallback };
    }
    if (gs.boxer.pending) {
      if ((t = rungText(artifacts, caseRow, 'claim_boxer')) != null) return { rung: 'claim_boxer', message: t };
      return { rung: 'claim_boxer', message: artifacts.ui.claimBoxerFallback };
    }
    if (gs.tee.pending) {
      if ((t = rungText(artifacts, caseRow, 'claim_tee')) != null) return { rung: 'claim_tee', message: t };
      return { rung: 'claim_tee', message: artifacts.ui.claimTeeFallback };
    }
    if ((t = rungText(artifacts, caseRow, 'push')) != null) return { rung: 'push', message: t };
    if ((t = rungText(artifacts, caseRow, 'affirm')) != null) return { rung: 'affirm', message: t };
    return { rung: 'none', message: '' };
  }

  /* ---------- §6 the resolution engine ----------
     Zone independence (R-16) is structural: each resolver receives
     only its own category's lines; nothing crosses zones (AG-04). */
  function distinctBy(lines, keyFn) {
    var seen = {}, out = [];
    for (var i = 0; i < lines.length; i++) {
      var k = keyFn(lines[i]);
      if (!seen[k]) { seen[k] = true; out.push(lines[i]); }
    }
    return out;
  }

  /* R-17 — the (waist,length) pair is atomic: one distinct pair
     resolves, two+ is a conflict that resolves NOTHING (no partial
     waist — R-25's source of truth). */
  function resolvePants(pantLines) {
    if (!pantLines.length) return { status: 'unresolved' };
    var d = distinctBy(pantLines, function (l) { return norm(l.sizeAttrs.waist) + '||' + norm(l.sizeAttrs.length); });
    if (d.length === 1) return { status: 'resolved', values: { waist: d[0].sizeAttrs.waist, length: d[0].sizeAttrs.length }, signal: 'explicit' };
    return { status: 'conflict' };
  }

  /* R-18 */
  function resolveTee(teeLines) {
    if (!teeLines.length) return { status: 'unresolved' };
    var d = distinctBy(teeLines, function (l) { return norm(l.sizeAttrs.size); });
    if (d.length === 1) return { status: 'resolved', values: { size: d[0].sizeAttrs.size }, signal: 'explicit' };
    return { status: 'conflict' };
  }

  /* R-19/R-20/R-21 + L-01. Derivation is one-way pants->boxer only. */
  function resolveBoxer(boxerLines, pantsResolution, mapping, derivedLength) {
    if (boxerLines.length) {
      var d = distinctBy(boxerLines, function (l) { return norm(l.sizeAttrs.length) + '||' + norm(l.sizeAttrs.size); });
      if (d.length === 1) return { status: 'resolved', values: { length: d[0].sizeAttrs.length, size: d[0].sizeAttrs.size }, signal: 'explicit' }; /* R-21: explicit beats derived, always */
      /* L-01 (adopted default): explicit conflict -> unresolved, even
         when a valid derivation exists — derivation never overrides
         explicit signals, broken or not. */
      return { status: 'conflict' };
    }
    /* R-20: ANY pants conflict kills derivation entirely — we never
       even look at the mapping (AG-05: no comparing outputs). */
    if (pantsResolution.status !== 'resolved') return { status: 'unresolved' };
    var size = mapping[pairKey(pantsResolution.values.waist, pantsResolution.values.length)];
    if (!size) return { status: 'unresolved' }; /* absent pair = no derivation (§11.3, A-14) */
    return { status: 'resolved', values: { length: derivedLength, size: size }, signal: 'derived' };
  }

  function resolveSizes(lines, artifacts) {
    var by = { pants: [], tee: [], boxer: [] };
    for (var i = 0; i < lines.length; i++) by[lines[i].category].push(lines[i]);
    var pants = resolvePants(by.pants);
    return {
      pants: pants,
      tee: resolveTee(by.tee),
      boxer: resolveBoxer(by.boxer, pants, artifacts.boxerMapping, artifacts.derivedBoxerLength)
    };
  }

  /* ---------- §7 eligibility & exclusion (R-13 — the ONLY exclusion site) ---------- */
  function ownedColors(lines) {
    var owned = { pants: {}, tee: {}, boxer: {} };
    for (var i = 0; i < lines.length; i++) {
      if (lines[i].color != null) owned[lines[i].category][norm(lines[i].color)] = true;
    }
    return owned;
  }

  /* per-category color index over the adapter's products:
     display name, carrying products, availability, variant lookup */
  function colorProducts(category, catalog, adapter) {
    var def = adapter.categories[category];
    var out = {}; /* norm(color) -> { display, handles: [] } */
    var colorDef = def.attributes.color;
    for (var i = 0; i < def.products.length; i++) {
      var p = catalog.products[def.products[i]];
      if (!p) continue;
      if (colorDef.source === 'product') {
        var val = identityValue(p, colorDef.identityOption);
        if (val == null) continue;
        var k = norm(val);
        if (!out[k]) out[k] = { display: val, handles: [] };
        out[k].handles.push(p.handle);
      } else {
        var idx = optionIndex(p, colorDef.option);
        if (idx < 0) continue;
        for (var vi = 0; vi < p.variants.length; vi++) {
          var cv = p.variants[vi][idx + 1];
          var ck = norm(cv);
          if (!out[ck]) out[ck] = { display: cv, handles: [] };
          if (out[ck].handles.indexOf(p.handle) < 0) out[ck].handles.push(p.handle);
        }
      }
    }
    return out;
  }

  /* variant matching: attrs = { color + every size attribute } ->
     the ONE exact variant, or null. Exact match only (R-22): a
     missing variant is treated as unavailable under R-13b. */
  function variantFor(category, attrs, catalog, adapter) {
    var def = adapter.categories[category];
    for (var i = 0; i < def.products.length; i++) {
      var p = catalog.products[def.products[i]];
      if (!p) continue;
      /* identity-sourced attrs pick the product */
      var identityOk = true;
      var name;
      for (name in def.attributes) {
        if (!Object.prototype.hasOwnProperty.call(def.attributes, name)) continue;
        var ad = def.attributes[name];
        if (ad.source !== 'product') continue;
        if (norm(identityValue(p, ad.identityOption)) !== norm(attrs[name])) { identityOk = false; break; }
      }
      if (!identityOk) continue;
      /* option-sourced attrs pick the variant inside it */
      for (var vi = 0; vi < p.variants.length; vi++) {
        var tup = p.variants[vi];
        var ok = true;
        for (name in def.attributes) {
          if (!Object.prototype.hasOwnProperty.call(def.attributes, name)) continue;
          var od = def.attributes[name];
          if (od.source !== 'option') continue;
          var oi = optionIndex(p, od.option);
          if (oi < 0 || norm(tup[oi + 1]) !== norm(attrs[name])) { ok = false; break; }
        }
        if (ok) return { id: tup[0], available: !!tup[4], handle: p.handle, image: tup[5] || p.image || null };
      }
    }
    return null;
  }

  function colorFullyUnavailable(category, colorKey, colorIdx, catalog, adapter) {
    var entry = colorIdx[colorKey];
    if (!entry) return true;
    var def = adapter.categories[category];
    var colorDef = def.attributes.color;
    for (var i = 0; i < entry.handles.length; i++) {
      var p = catalog.products[entry.handles[i]];
      if (!p) continue;
      var idx = colorDef.source === 'option' ? optionIndex(p, colorDef.option) : -1;
      for (var vi = 0; vi < p.variants.length; vi++) {
        var tup = p.variants[vi];
        if (!tup[4]) continue;
        if (idx >= 0 && norm(tup[idx + 1]) !== colorKey) continue;
        return false; /* one available variant of this color exists */
      }
    }
    return true;
  }

  /* predicted variant for a color under a RESOLVED category (R-13b) */
  function predictedVariant(category, colorDisplay, resolution, catalog, adapter) {
    if (resolution.status !== 'resolved') return null;
    var attrs = { color: colorDisplay };
    for (var k in resolution.values) {
      if (Object.prototype.hasOwnProperty.call(resolution.values, k)) attrs[k] = resolution.values[k];
    }
    return variantFor(category, attrs, catalog, adapter);
  }

  /* walk the ranked list top-down keeping eligible colors (R-12/R-13) */
  function eligibleColors(category, resolution, owned, catalog, adapter, ranked) {
    var out = [];
    var colorIdx = colorProducts(category, catalog, adapter);
    var list = ranked[category] || [];
    for (var i = 0; i < list.length; i++) {
      var key = norm(list[i]);
      var entry = colorIdx[key];
      if (!entry) continue;                       /* not on the store */
      if (owned[category][key]) continue;         /* R-13a ownership (color-level, AM-03c) */
      if (resolution.status === 'resolved') {
        var pv = predictedVariant(category, entry.display, resolution, catalog, adapter);
        if (!pv || !pv.available) continue;       /* R-13b predicted variant unavailable */
        out.push({ color: entry.display, colorKey: key, predictedVariantId: pv.id, handle: pv.handle, image: pv.image });
      } else {
        if (colorFullyUnavailable(category, key, colorIdx, catalog, adapter)) continue; /* R-13c */
        out.push({ color: entry.display, colorKey: key, predictedVariantId: null, handle: entry.handles[0], image: (catalog.products[entry.handles[0]] || {}).image || null });
      }
    }
    return out;
  }

  /* ---------- §8.1 tile state + §6.3 pre-fill law ---------- */
  /* R-24/R-25: CART-resolved attributes arrive pre-filled; under
     CONFLICT nothing pre-fills (AG-07) — the attrs here are size
     attributes only. The tile's own color is not a cart signal
     (R-22: a single-color tile resolves its color by definition) and
     travels as tile.color, which the selector treats as the product
     context, never as a resolution output. */
  function prefillFor(tile, resolution) {
    if (resolution.status === 'conflict') return { mode: 'clean', attrs: {} };
    var attrs = {};
    if (resolution.status === 'resolved') {
      for (var k in resolution.values) {
        if (Object.prototype.hasOwnProperty.call(resolution.values, k)) attrs[k] = resolution.values[k];
      }
    }
    return { mode: 'prefill', attrs: attrs };
  }

  /* partial-match availability probe for the selector surfaces: is any
     variant available matching every SPECIFIED attribute? (Unspecified
     attributes are free.) Read-only helper; not an exclusion site. */
  function anyAvailableVariant(category, partialAttrs, catalog, adapter) {
    var def = adapter.categories[category];
    for (var i = 0; i < def.products.length; i++) {
      var p = catalog.products[def.products[i]];
      if (!p) continue;
      var identityOk = true;
      var name;
      for (name in def.attributes) {
        if (!Object.prototype.hasOwnProperty.call(def.attributes, name)) continue;
        var ad = def.attributes[name];
        if (ad.source !== 'product' || partialAttrs[name] == null) continue;
        if (norm(identityValue(p, ad.identityOption)) !== norm(partialAttrs[name])) { identityOk = false; break; }
      }
      if (!identityOk) continue;
      for (var vi = 0; vi < p.variants.length; vi++) {
        var tup = p.variants[vi];
        if (!tup[4]) continue;
        var ok = true;
        for (name in def.attributes) {
          if (!Object.prototype.hasOwnProperty.call(def.attributes, name)) continue;
          var od = def.attributes[name];
          if (od.source !== 'option' || partialAttrs[name] == null) continue;
          var oi = optionIndex(p, od.option);
          if (oi < 0 || norm(tup[oi + 1]) !== norm(partialAttrs[name])) { ok = false; break; }
        }
        if (ok) return true;
      }
    }
    return false;
  }

  /* distinct display values of an attribute across a category's
     products (selector row values): option-sourced -> option values;
     identity-sourced -> one value per product, product order. */
  function attributeValues(category, attrName, catalog, adapter) {
    var def = adapter.categories[category];
    var ad = def.attributes[attrName];
    var out = [], seen = {};
    if (!ad) return out;
    for (var i = 0; i < def.products.length; i++) {
      var p = catalog.products[def.products[i]];
      if (!p) continue;
      if (ad.source === 'product') {
        var val = identityValue(p, ad.identityOption);
        if (val != null && !seen[norm(val)]) { seen[norm(val)] = true; out.push(val); }
      } else {
        var oi = optionIndex(p, ad.option);
        if (oi < 0) continue;
        for (var vi = 0; vi < p.variants.length; vi++) {
          var v = p.variants[vi][oi + 1];
          if (v != null && !seen[norm(v)]) { seen[norm(v)] = true; out.push(v); }
        }
      }
    }
    return out;
  }

  /* ---------- the array (§7 render + §8 state) ---------- */
  function buildTiles(caseRow, resolutions, owned, catalog, adapter, ranked, giftConsumed) {
    var tiles = [];
    var tpl = caseRow.template || [];
    var eligCache = {}; /* category -> full eligible walk (computed once) */
    var cursor = {};    /* category -> continuation index (M-10) */
    for (var s = 0; s < tpl.length; s++) {
      var seg = tpl[s];
      var resolution = resolutions[seg.category];
      if (!eligCache[seg.category]) {
        eligCache[seg.category] = eligibleColors(seg.category, resolution, owned, catalog, adapter, ranked);
        cursor[seg.category] = 0;
      }
      var eligible = eligCache[seg.category];
      if (seg.tile_mode === 'single-color') {
        /* M-10: later segments of a category CONTINUE the ranked walk —
           each eligible color renders at most once per array. Colors a
           gift tile already renders are skipped without consuming cap. */
        var consumedSet = (giftConsumed && giftConsumed[seg.category]) || null;
        var start = cursor[seg.category];
        var cap = seg.cap != null ? seg.cap : Infinity;
        var taken = 0;
        var i = start;
        for (; i < eligible.length && taken < cap; i++) {
          var e = eligible[i];
          if (consumedSet && consumedSet[e.colorKey]) continue;
          taken++;
          var tile = {
            category: seg.category,
            tile_mode: 'single-color',
            color: e.color,
            image: e.image,
            handle: e.handle,
            /* R-22: zero unresolved -> instant-add. For a single-color
               tile that survived R-13b under a resolved category, the
               predicted variant exists by construction. */
            state: resolution.status === 'resolved' ? 'instant-add' : 'selector',
            predictedVariantId: resolution.status === 'resolved' ? e.predictedVariantId : null
          };
          tile.label = tile.state === 'instant-add' ? MPCC_INSTANT_ADD_LABEL : caseRow.selector_label;
          tile.prefill = prefillFor(tile, resolution);
          tiles.push(tile);
        }
        cursor[seg.category] = i;
      } else {
        /* all-colors: one tile representing the category; excluded only
           when every color is individually excluded (R-13d). ALWAYS
           selector state (R-23/AG-10) — no exception, ever. Does not
           consume the continuation cursor. */
        if (!eligible.length) continue;
        var ac = {
          category: seg.category,
          tile_mode: 'all-colors',
          color: null,
          heroColor: eligible[0].color,
          image: eligible[0].image,
          handle: eligible[0].handle,
          state: 'selector',
          predictedVariantId: null
        };
        ac.label = caseRow.selector_label;
        ac.prefill = prefillFor(ac, resolution);
        tiles.push(ac);
      }
    }
    return tiles; /* exclusions shorten the array; nothing backfills (R-14/AG-01) */
  }

  /* M-07.5 — the launch switch: when a dedicated gift product is
     configured (gifts[k].handle) AND present in the catalog island,
     claims add ITS variant matching the chosen option values; until
     then the regular product's variant is added (deferred-backend
     mode). Either way the line is tagged _mpcc_gift. Launch = set the
     handle in MPCC_GIFTS + append it to the Liquid island roster. */
  function giftVariantFor(giftKind, attrs, catalog, artifacts) {
    var g = artifacts.gifts[giftKind];
    if (!g) return null;
    if (g.handle && catalog.products[g.handle]) {
      var p = catalog.products[g.handle];
      var catDef = artifacts.adapter.categories[g.category];
      for (var vi = 0; vi < p.variants.length; vi++) {
        var tup = p.variants[vi];
        var ok = true;
        for (var name in attrs) {
          if (!Object.prototype.hasOwnProperty.call(attrs, name) || attrs[name] == null) continue;
          var ad = catDef.attributes[name];
          if (!ad) continue;
          var optName = ad.source === 'option' ? ad.option : ad.identityOption;
          var oi = optionIndex(p, optName);
          if (oi < 0 || norm(tup[oi + 1]) !== norm(attrs[name])) { ok = false; break; }
        }
        if (ok && tup[4]) return { id: tup[0], available: true, handle: p.handle, image: tup[5] || p.image || null };
      }
      return null; /* configured gift product lacks/OOS that variant */
    }
    return variantFor(g.category, attrs, catalog, artifacts.adapter);
  }

  /* ---------- M-09 gift tiles (engine-prepended when pending) ---------- */
  /* M-13/M-14: `pending` already encodes the one-gift model, so the
     tile builder needs no windows of its own — at >=$280 unclaimed
     BOTH tee and boxer tiles render (the either/or choice; the bar
     copy carries the "pick one", and claiming either ends the other
     offer on the very next derivation). With the boxer claimed the
     tee tile renders alone as the swap/upgrade offer. Labels/buttons
     unchanged (M-09: 🎁 + name, button always the claim label). */
  /* Boxer gift selector prefill: pants conflict -> clean (R-25);
     explicit boxer in cart -> its size (R-21); pants resolved ->
     mapped size (missing pair -> M); no signal -> M (L-08). */
  function boxerGiftPrefill(resolutions, artifacts) {
    if (resolutions.pants.status === 'conflict') return { mode: 'clean', attrs: {} };
    if (resolutions.boxer.status === 'resolved') return { mode: 'prefill', attrs: { size: resolutions.boxer.values.size } };
    if (resolutions.pants.status === 'resolved') {
      var mapped = artifacts.boxerMapping[pairKey(resolutions.pants.values.waist, resolutions.pants.values.length)];
      return { mode: 'prefill', attrs: { size: mapped || 'M' } };
    }
    return { mode: 'prefill', attrs: { size: 'M' } };
  }
  function heroFor(category, eligible, catalog, adapter) {
    if (eligible.length) return { image: eligible[0].image, handle: eligible[0].handle };
    var first = catalog.products[adapter.categories[category].products[0]];
    return { image: first ? first.image : null, handle: first ? first.handle : null };
  }
  function buildGiftTiles(gs, resolutions, owned, catalog, adapter, artifacts) {
    var tiles = [];
    /* order per the pack's arrays: tee gift tiles first, then boxer */
    if (gs.tee.pending) {
      var teeRes = resolutions.tee;
      var teeElig = eligibleColors('tee', teeRes, owned, catalog, adapter, artifacts.rankedColors);
      var teeIA = 0;
      if (teeRes.status === 'resolved' && teeElig.length) {
        /* size known -> up to 2 one-tap claim color tiles; the claim
           variant resolves through the M-07.5 switch */
        for (var i = 0; i < teeElig.length && i < 2; i++) {
          var e = teeElig[i];
          var gv = giftVariantFor('tee', { color: e.color, size: teeRes.values.size }, catalog, artifacts);
          if (!gv) continue; /* configured gift product lacks this variant — honest skip */
          teeIA++;
          tiles.push({
            gift: true, giftKind: 'tee', category: 'tee', tile_mode: 'single-color',
            color: e.color, image: e.image, handle: gv.handle,
            state: 'instant-add', predictedVariantId: gv.id,
            name: '🎁 ' + String(e.color).toUpperCase(), label: MPCC_CLAIM_LABEL,
            prefill: { mode: 'prefill', attrs: { size: teeRes.values.size } }
          });
        }
      }
      if (!teeIA) {
        /* size unknown, every color owned, or no claimable one-tap
           variant -> one selector tile; ownership governs tiles, not
           the panel (A4.3) */
        var teeHero = heroFor('tee', teeElig, catalog, adapter);
        tiles.push({
          gift: true, giftKind: 'tee', category: 'tee', tile_mode: 'gift-selector',
          color: null, image: teeHero.image, handle: teeHero.handle,
          state: 'selector', predictedVariantId: null,
          name: '🎁 ' + artifacts.gifts.tee.name, label: MPCC_CLAIM_LABEL,
          prefill: teeRes.status === 'resolved'
            ? { mode: 'prefill', attrs: { size: teeRes.values.size } }
            : (teeRes.status === 'conflict' ? { mode: 'clean', attrs: {} } : { mode: 'prefill', attrs: {} })
        });
      }
    }
    if (gs.boxer.pending) {
      var boxElig = eligibleColors('boxer', resolutions.boxer, owned, catalog, adapter, artifacts.rankedColors);
      var boxHero = heroFor('boxer', boxElig, catalog, adapter);
      tiles.push({
        gift: true, giftKind: 'boxer', category: 'boxer', tile_mode: 'gift-selector',
        color: null, image: boxHero.image, handle: boxHero.handle,
        state: 'selector', predictedVariantId: null,
        name: '🎁 ' + artifacts.gifts.boxer.name, label: MPCC_CLAIM_LABEL,
        prefill: boxerGiftPrefill(resolutions, artifacts)
      });
    }
    return tiles;
  }

  /* ---------- the pipeline — pure in, pure out ---------- */
  function runPipeline(cart, catalog, artifacts) {
    var lines = abstractLines(cart, catalog, artifacts.adapter, artifacts.gifts);
    var counts = countUnits(lines);
    var combo = comboOf(counts, artifacts.buckets);
    var caseRow = caseFor(combo, artifacts);
    var resolutions = resolveSizes(lines, artifacts);
    var owned = ownedColors(lines);
    var paidCents = paidSubtotal(cart, artifacts.gifts);
    var tiers = (cart && cart.tiers) || [0, 0, 0];
    var gs = giftStates(paidCents, lines, tiers, artifacts.gifts);
    var sel = caseRow ? selectRung(artifacts, caseRow, gs) : { rung: 'none', message: '' };
    var giftTiles = caseRow ? buildGiftTiles(gs, resolutions, owned, catalog, artifacts.adapter, artifacts) : [];
    /* colors already rendered by one-tap gift tiles must not re-render
       as paid tiles in the same array (M-10/A-25) */
    var giftConsumed = {};
    for (var gi = 0; gi < giftTiles.length; gi++) {
      var gt = giftTiles[gi];
      if (gt.tile_mode === 'single-color' && gt.color != null) {
        if (!giftConsumed[gt.category]) giftConsumed[gt.category] = {};
        giftConsumed[gt.category][norm(gt.color)] = true;
      }
    }
    var paidTiles = caseRow ? buildTiles(caseRow, resolutions, owned, catalog, artifacts.adapter, artifacts.rankedColors, giftConsumed) : [];
    return {
      combo: combo,
      counts: counts,
      row: caseRow,               /* kept name: render + leadSig read result.row */
      caseId: caseRow ? caseRow.id : null,
      rung: sel.rung,
      message: sel.message,
      selectorLabel: caseRow ? caseRow.selector_label : '',
      resolutions: resolutions,
      owned: owned,
      paidSubtotal: paidCents,
      gifts: gs,
      tiles: giftTiles.concat(paidTiles)
    };
  }

  var SHIPPED_ARTIFACTS = {
    buckets: MPCC_BUCKETS,
    caseTable: MPCC_CASE_TABLE,
    comboToCase: MPCC_COMBO_TO_CASE,
    gifts: MPCC_GIFTS,
    copy: MPCC_COPY,
    rankedColors: MPCC_RANKED_COLORS,
    boxerMapping: MPCC_BOXER_MAPPING,
    derivedBoxerLength: MPCC_DERIVED_BOXER_LENGTH,
    adapter: MPCC_STORE_ADAPTER,
    ui: MPCC_UI_STRINGS,
    instantAddLabel: MPCC_INSTANT_ADD_LABEL,
    claimLabel: MPCC_CLAIM_LABEL
  };

  window.MPCC = {
    artifacts: SHIPPED_ARTIFACTS,
    validateConfig: validateConfig,
    runPipeline: runPipeline,
    abstractLines: abstractLines,
    countUnits: countUnits,
    bucket: bucket,
    comboOf: comboOf,
    caseFor: caseFor,
    paidSubtotal: paidSubtotal,
    giftStates: giftStates,
    selectRung: selectRung,
    resolveSizes: resolveSizes,
    resolvePants: resolvePants,
    resolveTee: resolveTee,
    resolveBoxer: resolveBoxer,
    eligibleColors: eligibleColors,
    predictedVariant: predictedVariant,
    variantFor: variantFor,
    giftVariantFor: giftVariantFor,
    anyAvailableVariant: anyAvailableVariant,
    attributeValues: attributeValues,
    prefillFor: prefillFor,
    pairKey: pairKey,
    norm: norm
  };

  /* fail loudly in dev/harness; in production a broken config
     suppresses the widget (chrome untouched) rather than render wrong */
  var configViolations = validateConfig(SHIPPED_ARTIFACTS, null);
  window.MPCC.configViolations = configViolations;
  if (configViolations.length) {
    console.error('[mpcc] config artifact validation failed:', configViolations);
    if (window.__mpccHarness || (window.Shopify && window.Shopify.designMode)) {
      throw new Error('[mpcc] invalid config artifacts: ' + configViolations.join('; '));
    }
  }
})();

/* ============ MPCC cart drawer — picker core + cart plumbing ============
   Delegation-first: the drawer light DOM is wholesale-replaced on every
   cart change (theme CartDrawer.replaceContent), so no node references are
   kept across renders. State lives here; DOM is re-queried per use. */
(function () {
  'use strict';

  var P = { open: false, tileKey: null, rowCount: 0, busy: false, commitPending: false,
            lastResult: null, lastCatalog: null, lastAddHandle: null };
  var toastKeep = { msg: '', until: 0 };
  var toastTimer = null;
  var ghostBusy = false;
  var ghostTimer = null;
  var availPatch = {};   /* handle -> { variantId: available } — L-03 revalidation */
  var lastLeadSig = '';  /* L-02 scroll preservation across re-renders */
  var lastStripScroll = 0; /* tracked live in bindStrip — survives the theme's DOM replacement */
  var busyWatchdog = null; /* L-03 backstop: a submit that never yields
      cart-drawer:refreshed OR cart:error (e.g. network death inside the
      theme's own submit handler) must not leave the widget stuck busy */
  function armBusyWatchdog() {
    clearTimeout(busyWatchdog);
    busyWatchdog = setTimeout(function () {
      if (!P.busy) return;
      P.busy = false;
      P.commitPending = false;
      var stuck = q('[data-mpcc-tile][aria-busy="true"]');
      if (stuck) stuck.removeAttribute('aria-busy');
      var ui = window.MPCC ? window.MPCC.artifacts.ui : {};
      toast(ui.addFailedGeneric || 'Something went wrong — try again');
    }, 10000);
  }

  function root() { return document.querySelector('cart-drawer.mpcc-cart'); }
  function q(sel) { var r = root(); return r ? r.querySelector(sel) : null; }
  /* the shared add form lives at the END of document.body (mounted from
     the drawer's template) so it is never the page's first /cart/add
     form — Klaviyo's BIS button anchors to the first match and was
     landing inside the closed drawer (live find, 2026-08-24). */
  function mountPickerForm() {
    if (document.querySelector('form[data-mpcc-picker-form]')) return;
    var r = root();
    var tpl = r && r.querySelector('template[data-mpcc-form-tpl]');
    if (tpl && document.body) document.body.appendChild(tpl.content.cloneNode(true));
  }
  function pickerForm() {
    mountPickerForm();
    return document.querySelector('form[data-mpcc-picker-form]');
  }
  function isDesktop() { return window.matchMedia('(min-width: 990px)').matches; }

  function config() {
    var el = q('[data-mpcc-config]');
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  }
  function islandJSON(sel) {
    var el = q(sel);
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  }
  function parseHints(raw) {
    var map = {};
    String(raw || '').split(/\r?\n/).forEach(function (line) {
      var i = line.indexOf(':');
      if (i > 0) map[line.slice(0, i).trim().toUpperCase()] = line.slice(i + 1).trim();
    });
    return map;
  }
  function cssColorValid(name) {
    var s = new Option().style;
    s.color = '';
    s.color = name;
    return s.color !== '';
  }

  function toast(msg) {
    var el = q('[data-mpcc-toast]');
    if (!el || !msg) return;
    toastKeep = { msg: msg, until: Date.now() + 3000 };
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      var cur = q('[data-mpcc-toast]');
      if (cur) cur.classList.remove('is-on');
    }, 3000);
  }

  /* ---------- cart plumbing ---------- */
  function sectionId() {
    var r = root();
    return r ? r.getAttribute('data-section-id') : '';
  }
  function dispatchCartChange(cartJson, baseEvent) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: baseEvent, cart: cartJson }
    }));
  }
  /* all cart mutations run through one serial queue: a qty tap racing
     the ghost-sync update on the same cart token is how Shopify's cart
     lock produces spurious errors (seen live on mobile) */
  var mutateQueue = Promise.resolve();
  function shopifyRoot() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }
  /* sheet §M-1 (2026-08-04, batched into this build round): a queued
     /cart/change captured from a stale button can target a line that
     no longer exists; Shopify answers HTTP 400 with the raw
     description "No valid id or line parameter" — a no-op by
     definition, but shopper-visible dev-speak when surfaced. */
  var STALE_LINE_400 = /no valid id or line parameter/i;
  function lineStillInCart(lineKey) {
    var cart = islandJSON('[data-mpcc-cart]');
    if (!cart || !cart.items) return true; /* cannot verify -> dispatch normally */
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].key) === String(lineKey)) return true;
    }
    return false;
  }
  function cartMutate(url, payload, baseEvent) {
    payload.sections = sectionId();
    var run = function () {
      /* §M-1 fix (1) — dispatch-time validation: a line-targeting
         change whose line is already gone from the freshest server
         render (the cart island) is skipped outright; the DOM is
         already truthful, so there is nothing to re-render. */
      if (payload.id != null && payload.quantity != null && !lineStillInCart(payload.id)) {
        return Promise.resolve(islandJSON('[data-mpcc-cart]'));
      }
      return fetch(url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        if (res.ok) {
          return res.json().then(function (json) {
            dispatchCartChange(json, baseEvent);
            return json;
          });
        }
        /* surface Shopify's own shopper-facing explanation when it
           sends one (e.g. inventory limits) */
        return res.json().catch(function () { return {}; }).then(function (j) {
          /* §M-1 fix (2) — the stale-line 400 slipped past the island
             check (island staleness): never surface it; converge to
             truth instead and resolve as a successful no-op. */
          if (STALE_LINE_400.test(String(j.description || ''))) {
            return fetch(shopifyRoot() + 'cart.js')
              .then(function (r) { return r.json(); })
              .then(function (fresh) {
                dispatchCartChange(fresh, baseEvent);
                return fresh;
              });
          }
          throw new Error(j.description || j.message || 'cart request failed');
        });
      });
    };
    var p = mutateQueue.then(run, run);
    mutateQueue = p.catch(function () {});
    return p;
  }

  /* quantity +/- and remove (delegated; buttons re-render each change) */
  document.addEventListener('click', function (e) {
    var r = root();
    if (!r) return;
    var qbtn = e.target.closest('[data-mpcc-qty]');
    if (qbtn && r.contains(qbtn)) {
      e.preventDefault();
      if (qbtn.getAttribute('aria-busy') === 'true') return;
      qbtn.setAttribute('aria-busy', 'true');
      var lineKey = qbtn.getAttribute('data-mpcc-qty');
      var wantQty = Math.max(0, parseInt(qbtn.getAttribute('data-mpcc-qty-to'), 10) || 0);
      cartMutate(r.getAttribute('data-routes-change'), {
        id: lineKey,
        quantity: wantQty
      }, 'line-item:change').then(function (json) {
        /* Shopify silently CAPS a quantity at available inventory
           (200 OK, nothing changes) — say so instead of doing nothing */
        var line = (json.items || []).filter(function (i) { return i.key === lineKey; })[0];
        if (line && wantQty > line.quantity) {
          var ui = window.MPCC ? window.MPCC.artifacts.ui : {};
          toast(ui.stockCapped || 'That is all the stock we have');
        }
      }).catch(function (err) {
        /* failure = no re-render arrives, so the button must be
           re-enabled here or it stays dead */
        qbtn.removeAttribute('aria-busy');
        var msg = err && err.message && err.message !== 'cart request failed' ? err.message : null;
        toast(msg || (config() || {}).toastError || 'Something went wrong');
      });
      return;
    }
    var rm = e.target.closest('[data-mpcc-remove]');
    if (rm && r.contains(rm)) {
      e.preventDefault();
      cartMutate(r.getAttribute('data-routes-change'), {
        id: rm.getAttribute('data-mpcc-remove'),
        quantity: 0
      }, 'line-item:change').catch(function () { toast((config() || {}).toastError || 'Something went wrong'); });
    }
  });

  /* ---------- ghost line sync (qty follows pants count) ---------- */
  function syncGhost() {
    var r = root();
    if (!r || ghostBusy) return;
    var gid = r.getAttribute('data-ghost-variant');
    if (!gid) return;
    /* pants counted by the adapter's pants handles (spec model), not
       by product_type */
    var pantsHandles = window.MPCC ? window.MPCC.artifacts.adapter.categories.pants.products : [];
    ghostBusy = true;
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var pants = 0, ghost = 0;
        (cart.items || []).forEach(function (item) {
          if (String(item.variant_id) === gid) { ghost = item.quantity; return; }
          if (pantsHandles.indexOf(item.handle) >= 0) pants += item.quantity;
        });
        if (ghost === pants) return null;
        var updates = {};
        updates[gid] = pants;
        return cartMutate(r.getAttribute('data-routes-update'), { updates: updates }, 'ghost-sync');
      })
      .catch(function () {})
      .finally(function () { ghostBusy = false; });
  }
  function scheduleGhost() {
    clearTimeout(ghostTimer);
    ghostTimer = setTimeout(syncGhost, 400);
  }
  document.addEventListener('cart:change', function (e) {
    if (!e.detail || e.detail.baseEvent !== 'ghost-sync') scheduleGhost();
  });
  setInterval(syncGhost, 4000);

  /* ---------- spec widget: pipeline result -> DOM ---------- */
  function tileKeyOf(tile) { return tile.category + '|' + tile.tile_mode + '|' + (tile.color || '*'); }
  function leadSig(result) {
    if (!result.row || !result.tiles.length) return '';
    var first = result.row.template[0];
    var lead = result.tiles.filter(function (t) { return t.category === first.category && t.tile_mode === first.tile_mode; });
    return first.category + '|' + first.tile_mode + '|' + lead.map(function (t) { return t.color || '*'; }).join(',');
  }
  function buildTileEl(tile, idx) {
    /* R-27: the whole tile is ONE tap target — image, label, button
       are a single element with a single action (AG-11) */
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mpcc-card mpcc-card--tile' + (tile.gift ? ' mpcc-card--gift' : '');
    b.setAttribute('data-mpcc-tile', String(idx));
    var ui = window.MPCC.artifacts.ui;
    /* gift tiles carry their authored 🎁 name (M-09); paid tiles show
       the color, ac tiles the category + ALL COLORS */
    var nameText = tile.name || (tile.tile_mode === 'all-colors'
      ? ui.categoryNames[tile.category] + ' · ' + ui.allColors
      : tile.color);
    b.setAttribute('aria-label', tile.label + ' — ' + nameText + ' ' + ui.categoryNames[tile.category]);
    var name = document.createElement('span');
    name.className = 'mpcc-card__name';
    name.textContent = nameText;
    var fig = document.createElement('span');
    fig.className = 'mpcc-card__figure';
    if (tile.image) {
      var img = document.createElement('img');
      img.className = 'mpcc-card__img';
      img.src = tile.image;
      img.alt = '';
      img.loading = 'lazy';
      fig.appendChild(img);
    }
    var cta = document.createElement('span');
    cta.className = 'mpcc-card__cta';
    cta.textContent = tile.label;
    b.appendChild(name);
    b.appendChild(fig);
    b.appendChild(cta);
    return b;
  }
  function renderWidget() {
    var mount = q('[data-mpcc-widget]');
    if (!mount || !window.MPCC) return;
    if (window.MPCC.configViolations.length) { mount.hidden = true; return; }
    var cart = islandJSON('[data-mpcc-cart]');
    var catalog = islandJSON('[data-mpcc-catalog]');
    if (!cart || !catalog) { mount.hidden = true; return; }
    /* §11.1 adapter/roster cross-check — runs once against the real
       catalog island (an unpublished or drifted rostered handle would
       otherwise vanish silently) */
    if (!P.catalogChecked) {
      P.catalogChecked = true;
      var xv = window.MPCC.validateConfig(window.MPCC.artifacts, catalog);
      if (xv.length) console.error('[mpcc] adapter/catalog mismatch:', xv);
    }
    /* L-03 revalidation results overlay the (older) server island;
       cleared whenever a fresh server render arrives */
    Object.keys(availPatch).forEach(function (h) {
      var p = catalog.products[h];
      if (!p) return;
      p.variants.forEach(function (tup) {
        var k = String(tup[0]);
        if (Object.prototype.hasOwnProperty.call(availPatch[h], k)) tup[4] = availPatch[h][k];
      });
    });
    var result = window.MPCC.runPipeline(cart, catalog, window.MPCC.artifacts);
    P.lastResult = result;
    P.lastCatalog = catalog;
    var banner = q('[data-mpcc-banner]');
    if (banner) {
      banner.textContent = result.message || '';
      banner.hidden = !result.message;
    }
    var strip = q('[data-mpcc-strip]');
    if (strip) {
      var sig = leadSig(result);
      strip.innerHTML = '';
      result.tiles.forEach(function (tile, idx) { strip.appendChild(buildTileEl(tile, idx)); });
      /* L-02: preserve horizontal scroll iff the leading segment is
         unchanged; reset on reshuffle. The position comes from
         lastStripScroll (tracked live in bindStrip) because the theme
         wholesale-replaces the strip element before this runs — the
         fresh node always reads scrollLeft 0. */
      if (sig && sig === lastLeadSig) {
        strip.scrollLeft = lastStripScroll;
      } else {
        strip.scrollLeft = 0;
        lastStripScroll = 0;
      }
      lastLeadSig = sig;
    }
    mount.hidden = false;
  }

  /* gift claims tag their line with the _mpcc_gift property (M-07.3);
     the disabled state keeps the input out of paid submissions */
  function setGiftProperty(form, isGift) {
    var input = form.querySelector('input[data-mpcc-gift-prop]');
    if (isGift) {
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[_mpcc_gift]';
        input.setAttribute('data-mpcc-gift-prop', '');
        form.appendChild(input);
      }
      input.value = '1';
      input.disabled = false;
    } else if (input) {
      input.disabled = true;
    }
  }

  /* M-07.4 + M-13 — post-render gift law enforcement. Two rules, one
     removal per pass so repeated refreshes converge; rides the serial
     mutation queue; honest toasts, no blocking dialogs (M-04):
       1. ONE GIFT MAX (M-13.1): boxer gift line AND tee gift line
          both present -> the boxer line leaves (the tee is the
          tier-3 gift). This IS the swap-on-claim back half (M-13.4):
          claiming the tee beside a claimed boxer lands here on the
          re-render and completes the serial swap chain. Also repairs
          legacy two-gift carts from the C-1 cumulative build.
       2. Threshold loss-guard (M-07.4/M-13.5): a claimed gift whose
          own threshold is no longer met leaves with the loss toast.
          (Boxer offer resurfacing after a tee loss at >=$180 is pure
          derivation — nothing to do here.) */
  var giftEnforceBusy = false;
  function enforceGiftEligibility() {
    if (giftEnforceBusy || !window.MPCC || !P.lastResult || !P.lastResult.gifts) return;
    var cart = islandJSON('[data-mpcc-cart]');
    if (!cart || !P.lastCatalog) return;
    var A = window.MPCC.artifacts;
    var lines = window.MPCC.abstractLines(cart, P.lastCatalog, A.adapter, A.gifts);
    var r = root();
    if (!r) return;
    var giftLineFor = function (catKey) {
      var gcat = A.gifts[catKey] ? A.gifts[catKey].category : null;
      for (var i = 0; i < lines.length; i++) {
        if (lines[i].gift && lines[i].category === gcat && lines[i].key) return lines[i];
      }
      return null;
    };
    var removeLine = function (line, msg) {
      giftEnforceBusy = true;
      toast(msg || 'Your free gift was removed');
      cartMutate(r.getAttribute('data-routes-change'), { id: line.key, quantity: 0 }, 'gift-enforce')
        .catch(function () {})
        .then(function () { giftEnforceBusy = false; });
    };
    /* rule 1 — one gift max: both categories claimed AND the tee is
       actually earned -> the boxer leaves (swap). With the tee BELOW
       its threshold (legacy cart shapes), rule 2's loss guard must
       take the tee instead — the boxer may still be valid. */
    var boxerLine = giftLineFor('boxer');
    if (boxerLine && giftLineFor('tee') && P.lastResult.gifts.tee && P.lastResult.gifts.tee.earned) {
      removeLine(boxerLine, A.ui.giftSwapped);
      return;
    }
    /* rule 2 — threshold loss-guard */
    for (var k in P.lastResult.gifts) {
      if (!Object.prototype.hasOwnProperty.call(P.lastResult.gifts, k)) continue;
      var g = P.lastResult.gifts[k];
      if (!g.claimed || g.earned) continue; /* claimed AND still earned = fine */
      var line = giftLineFor(k);
      if (line) {
        removeLine(line, (k === 'boxer' ? A.ui.giftLostBoxer : A.ui.giftLostTee));
        return;
      }
    }
  }

  /* R-26: instant add is truly instant — no dialog, no undo; the add
     rides the theme product-form with the EXACT predicted variant id
     (R-22 — never a substituted length). Gift one-tap claims
     use the same path with the gift property set. */
  function instantAdd(tile, el) {
    if (P.busy || !tile.predictedVariantId) return;
    P.busy = true;
    P.commitPending = false;
    P.lastAddHandle = tile.handle || null;
    if (el) el.setAttribute('aria-busy', 'true');
    var form = pickerForm();
    if (!form) { P.busy = false; return; }
    setGiftProperty(form, !!tile.gift);
    form.querySelector('input[name="id"]').value = tile.predictedVariantId;
    armBusyWatchdog();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.click(); else form.requestSubmit();
    /* success: the theme re-renders the drawer (R-28); the tapped tile
       vanishes via R-13(a). Failure: cart:error -> L-03 path, or the
       watchdog if neither event ever arrives. */
  }

  /* ---------- selector surfaces ---------- */
  /* AM-04: desktop side panel = mobile bottom sheet (one element, two
     shells); the mobile inline module serves 1-row selections. */
  function surfaceFor(rowCount) {
    if (isDesktop()) return 'panel';
    return rowCount === 1 ? 'inline' : 'sheet';
  }

  /* ---------- picker geometry: 2-pass placement ----------
     The picker's absolute containing block is unpredictable on the live
     theme: the drawer shell animates its shadow parts and the leftover
     inline transforms turn body/footer parts into containing blocks (found
     on-store: the panel anchored to the footer). So we never trust CSS
     anchoring — measure the drawer content box and place with a
     measure-then-delta pass that works from ANY containing block. */
  function drawerRect() {
    var r = root();
    if (!r) return null;
    var part = r.shadowRoot && r.shadowRoot.querySelector('[part~="content"]');
    var rect = (part || r).getBoundingClientRect();
    if (rect.width < 40) {
      var h = q('.mpcc-cart__heading');
      if (h) {
        var hr = h.getBoundingClientRect();
        rect = { left: hr.left, right: window.innerWidth, top: 0, bottom: window.innerHeight,
                 width: window.innerWidth - hr.left, height: window.innerHeight };
      }
    }
    return rect;
  }
  function placeAt(el, left, top, width, height) {
    var prevT = el.style.transform;
    el.style.transform = 'none';
    /* neutralize any CSS bottom/right anchors — with an inline top set,
       a stylesheet bottom:0 (anchored to whatever transformed ancestor
       is the containing block) over-constrains the box (found on a real
       iPhone: the sheet stretched against the tall footer part) */
    el.style.bottom = 'auto';
    if (width != null) { el.style.width = width + 'px'; el.style.right = 'auto'; }
    if (height != null) el.style.height = height + 'px';
    el.style.left = '0px';
    el.style.top = '0px';
    var r0 = el.getBoundingClientRect();
    el.style.left = (left - r0.left) + 'px';
    el.style.top = (top - r0.top) + 'px';
    el.style.transform = prevT;
  }
  function placePicker(surface) {
    var picker = q('[data-mpcc-picker]');
    var cr = drawerRect();
    if (!picker || !cr) return;
    if (surface === 'panel') {
      var w = Math.min(392, Math.max(280, cr.width * 0.86));
      placeAt(picker, cr.left - w, cr.top, w, cr.height);
    } else {
      /* SHEET: no JS placement at all — live CSS (bottom: 0 +
         max-height: 86dvh in the mobile block) stays glued to the
         containing block through every theme animation, which no
         measured-once JS position can do (real-iPhone lesson: a
         frozen top strands the sheet when the animated part settles;
         timer-based re-correction is throttled exactly on the phones
         that need it). Just clear any stale inline placement left by
         the panel path. */
      ['left', 'top', 'right', 'bottom', 'width', 'height', 'maxHeight'].forEach(function (prop) {
        picker.style[prop] = '';
      });
      var bd = q('[data-mpcc-backdrop]');
      if (bd) {
        ['left', 'top', 'right', 'bottom', 'width', 'height'].forEach(function (prop) {
          bd.style[prop] = '';
        });
      }
    }
  }
  function clearPlacement() {
    ['[data-mpcc-picker]', '[data-mpcc-backdrop]'].forEach(function (sel) {
      var el = q(sel);
      if (!el) return;
      el.style.left = el.style.top = el.style.right = el.style.bottom = '';
      el.style.width = el.style.height = el.style.maxHeight = '';
    });
  }
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (P.open && !P.busy) {
        var s = surfaceFor(P.rowCount || 2);
        if (s !== 'inline') placePicker(s);
      }
    }, 150);
  });


  /* commit from a selector: submit the exact chosen variant via the
     theme product-form. No cart-attribute writes anywhere (AM-02).
     No success toast either (Arda 2026-07-21): the picker's done-tick
     covers the instant before the re-render, and the re-rendered cart
     IS the confirmation (R-26 spirit). */
  function commitAdd(variantId, handle, isGift) {
    if (P.busy) return;
    P.busy = true;
    P.commitPending = true;
    P.lastAddHandle = handle || null;
    var done = q('[data-mpcc-done]');
    if (done) done.classList.add('is-on');
    var form = pickerForm();
    if (!form) { P.busy = false; P.commitPending = false; return; }
    setGiftProperty(form, !!isGift);
    form.querySelector('input[name="id"]').value = variantId;
    armBusyWatchdog();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.click(); else form.requestSubmit();
    /* success path: theme replaces drawer content (picker vanishes), then
       cart-drawer:refreshed closes the picker state */
  }
  /* L-03 — failed add: non-blocking toast, revalidate the product's
     availability, re-render; a sold-out tile disappears via R-13(b).
     A tile never silently does nothing. */
  document.addEventListener('cart:error', function () {
    if (!P.busy) return;
    clearTimeout(busyWatchdog);
    P.busy = false;
    P.commitPending = false;
    closePicker(true);
    var ui = window.MPCC ? window.MPCC.artifacts.ui : {};
    toast(ui.addFailedGeneric || 'Something went wrong — try again');
    var handle = P.lastAddHandle;
    if (!handle) { renderWidget(); return; }
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'products/' + handle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (pj) {
        var patch = {};
        (pj.variants || []).forEach(function (v) { patch[String(v.id)] = !!v.available; });
        availPatch[handle] = patch;
      })
      .catch(function () {})
      .then(function () { renderWidget(); });
  }, true);

  function buildPill(text, disabled) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mpcc-pill';
    b.textContent = text;
    b.disabled = !!disabled;
    b.setAttribute('aria-pressed', 'false');
    return b;
  }
  function setPressed(container, btn) {
    Array.prototype.forEach.call(container.children, function (s) {
      s.classList.remove('is-selected');
      s.setAttribute('aria-pressed', 'false');
    });
    if (btn) {
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
    }
  }
  function buildSwatch(name, disabled) {
    var b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('aria-label', name);
    b.setAttribute('aria-pressed', 'false');
    b.disabled = !!disabled;
    if (cssColorValid(name)) {
      b.className = 'mpcc-swatch';
      b.style.background = name;
    } else {
      b.className = 'mpcc-swatch mpcc-swatch--text';
      b.textContent = name;
    }
    return b;
  }

  /* one attribute group (label + hint + pills) in either shell */
  function makeGroup(rowsWrap, inline, labelText, hintText) {
    var g = document.createElement('div');
    g.className = inline ? 'mpcc-inline__group' : 'mpcc-picker__group';
    var lab = document.createElement('p');
    lab.className = inline ? 'mpcc-inline__label' : 'mpcc-picker__label';
    lab.textContent = labelText || '';
    var hint = document.createElement('p');
    hint.className = inline ? 'mpcc-inline__hint' : 'mpcc-picker__hint';
    hint.textContent = hintText || '';
    var pills = document.createElement('div');
    pills.className = inline ? 'mpcc-inline__pills' : 'mpcc-picker__pills';
    g.appendChild(lab);
    g.appendChild(hint);
    g.appendChild(pills);
    rowsWrap.appendChild(g);
    return { group: g, label: lab, hint: hint, pills: pills };
  }

  /* first catalog image for a partial attribute match (variant image
     swap on color pick — catalog carries variant images for small
     products only). Identity-sourced attributes (e.g. tee color =
     which product, AM-01) filter by PRODUCT; option-sourced ones by
     variant tuple. */
  function partialMatchImage(category, attrs) {
    if (!window.MPCC || !P.lastCatalog) return null;
    var def = window.MPCC.artifacts.adapter.categories[category];
    for (var i = 0; i < def.products.length; i++) {
      var p = P.lastCatalog.products[def.products[i]];
      if (!p) continue;
      var name;
      var identityOk = true;
      for (name in attrs) {
        if (!Object.prototype.hasOwnProperty.call(attrs, name) || attrs[name] == null) continue;
        var idDef = def.attributes[name];
        if (!idDef || idDef.source !== 'product') continue;
        var ioi = p.options.map(function (o) { return String(o).toLowerCase(); }).indexOf(String(idDef.identityOption).toLowerCase());
        var idVal = ioi >= 0 && p.variants.length ? p.variants[0][ioi + 1] : null;
        if (window.MPCC.norm(idVal) !== window.MPCC.norm(attrs[name])) { identityOk = false; break; }
      }
      if (!identityOk) continue;
      for (var vi = 0; vi < p.variants.length; vi++) {
        var tup = p.variants[vi];
        if (!tup[5]) continue;
        var ok = true;
        for (name in attrs) {
          if (!Object.prototype.hasOwnProperty.call(attrs, name) || attrs[name] == null) continue;
          var ad = def.attributes[name];
          if (!ad) continue;
          if (ad.source === 'option') {
            var oi = p.options.map(function (o) { return String(o).toLowerCase(); }).indexOf(String(ad.option).toLowerCase());
            if (oi < 0 || window.MPCC.norm(tup[oi + 1]) !== window.MPCC.norm(attrs[name])) { ok = false; break; }
          }
        }
        if (ok) return tup[5];
      }
    }
    return null;
  }

  /* generic attribute rows (tee/boxer selectors). Availability is
     probed live against the catalog: a value is disabled when no
     available variant matches it plus the current selections. Commit
     fires when every row is chosen and the exact variant exists. */
  function buildAttrRows(plan, rowsWrap, inline, cfg, imgEl, onCommit) {
    var A = window.MPCC.artifacts;
    var sizeHints = parseHints(cfg.sizeHints);
    var sel = {};
    var groups = {};
    function probeAttrs(overrideKey, overrideVal) {
      var attrs = {};
      Object.keys(plan.fixedAttrs).forEach(function (k) { attrs[k] = plan.fixedAttrs[k]; });
      plan.rows.forEach(function (row) { if (sel[row.key] != null) attrs[row.key] = sel[row.key]; });
      if (overrideKey) attrs[overrideKey] = overrideVal;
      return attrs;
    }
    function refreshRow(row) {
      var g = groups[row.key];
      var deselected = false;
      Array.prototype.forEach.call(g.pills.children, function (btn) {
        var val = btn.getAttribute('data-mpcc-val');
        var ok = window.MPCC.anyAvailableVariant(plan.category, probeAttrs(row.key, val), P.lastCatalog, A.adapter);
        btn.disabled = !ok;
        if (!ok && sel[row.key] === val) {
          sel[row.key] = null;
          btn.classList.remove('is-selected');
          btn.setAttribute('aria-pressed', 'false');
          deselected = true;
        }
      });
      return deselected;
    }
    function maybeCommit(btn) {
      var complete = plan.rows.every(function (row) { return sel[row.key] != null; });
      if (!complete) return;
      /* gift commits resolve through the M-07.5 switch (dedicated gift
         product when configured, else the regular product) */
      var v = plan.giftKind
        ? window.MPCC.giftVariantFor(plan.giftKind, probeAttrs(), P.lastCatalog, A)
        : window.MPCC.variantFor(plan.category, probeAttrs(), P.lastCatalog, A.adapter);
      if (!v || !v.available) {
        if (plan.giftKind) toast(A.ui.addFailedGeneric || 'Something went wrong — try again');
        return;
      }
      btn.classList.add('is-added');
      onCommit(v);
    }
    plan.rows.forEach(function (row) {
      var g = makeGroup(rowsWrap, inline, row.label, row.hint || '');
      groups[row.key] = g;
      sel[row.key] = null;
      row.values.forEach(function (val) {
        var btn = row.kind === 'swatch' ? buildSwatch(val, false) : buildPill(val, false);
        btn.setAttribute('data-mpcc-val', val);
        if (row.kind === 'pill' && row.key === 'size') {
          var showSizeHint = function () {
            var hk = String(val).toUpperCase();
            if (!btn.disabled && sizeHints[hk]) g.hint.textContent = val + ' — ' + sizeHints[hk];
          };
          btn.addEventListener('mouseenter', showSizeHint);
          btn.addEventListener('focus', showSizeHint); /* keyboard parity */
        }
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          sel[row.key] = val;
          setPressed(g.pills, btn);
          if (row.kind === 'swatch') {
            g.hint.textContent = val;
            /* variant-level image first (boxers carry per-variant imgs);
               identity-color categories (tees: color = which product)
               fall back to that product's card image */
            var vimg = partialMatchImage(plan.category, probeAttrs());
            if (!vimg && window.MPCC && P.lastCatalog) {
              var cdef = window.MPCC.artifacts.adapter.categories[plan.category];
              if (cdef && cdef.attributes.color && cdef.attributes.color.source === 'product') {
                for (var pi = 0; pi < cdef.products.length; pi++) {
                  var pp = P.lastCatalog.products[cdef.products[pi]];
                  if (!pp || !pp.variants.length) continue;
                  var ioi = pp.options.map(function (o) { return String(o).toLowerCase(); })
                    .indexOf(String(cdef.attributes.color.identityOption).toLowerCase());
                  if (ioi >= 0 && window.MPCC.norm(pp.variants[0][ioi + 1]) === window.MPCC.norm(val)) {
                    vimg = pp.image;
                    break;
                  }
                }
              }
            }
            if (vimg && imgEl) { imgEl.src = vimg; imgEl.hidden = false; }
          }
          /* a force-deselect changes the selection set — re-probe every
             row once more so no pill stays disabled against a selection
             that no longer exists */
          var cascaded = false;
          plan.rows.forEach(function (other) { if (other.key !== row.key) cascaded = refreshRow(other) || cascaded; });
          if (cascaded) plan.rows.forEach(refreshRow);
          maybeCommit(btn);
        });
        g.pills.appendChild(btn);
      });
      /* R-24: cart-resolved values arrive pre-filled (visible and
         changeable — only genuinely unknown choices remain). Under
         conflict the plan carries no pre values at all (R-25/AG-07). */
      if (row.pre != null) {
        Array.prototype.forEach.call(g.pills.children, function (btn) {
          if (window.MPCC.norm(btn.getAttribute('data-mpcc-val')) === window.MPCC.norm(row.pre)) {
            sel[row.key] = btn.getAttribute('data-mpcc-val');
            btn.classList.add('is-selected');
            btn.setAttribute('aria-pressed', 'true');
          }
        });
      }
    });
    plan.rows.forEach(refreshRow);
  }

  /* pants selector: the approved waist -> length two-step, over the
     tile's product from the catalog island */
  function buildPantsRows(plan, rowsWrap, inline, cfg, onCommit) {
    var p = plan.product;
    var lower = p.options.map(function (o) { return String(o).toLowerCase(); });
    var wi = lower.indexOf('waist');
    var li = lower.indexOf('length');
    if (wi < 0 || li < 0) return;
    var lengthHints = parseHints(cfg.lengthHints);
    var waists = [], lengths = [];
    p.variants.forEach(function (tup) {
      if (tup[wi + 1] != null && waists.indexOf(tup[wi + 1]) < 0) waists.push(tup[wi + 1]);
      if (tup[li + 1] != null && lengths.indexOf(tup[li + 1]) < 0) lengths.push(tup[li + 1]);
    });
    function avail(w, l) {
      return p.variants.some(function (tup) { return tup[4] && tup[wi + 1] === w && tup[li + 1] === l; });
    }
    function variantIdOf(w, l) {
      for (var i = 0; i < p.variants.length; i++) {
        var tup = p.variants[i];
        if (tup[4] && tup[wi + 1] === w && tup[li + 1] === l) return tup[0];
      }
      return null;
    }
    var gW = makeGroup(rowsWrap, inline, cfg.labelWaist, cfg.hintWaist || '');
    var gL = makeGroup(rowsWrap, inline, cfg.labelLength, cfg.hintLengthWait || '');
    var preWpill = null;
    waists.forEach(function (w) {
      var dead = !lengths.some(function (l) { return avail(w, l); });
      var b = buildPill(w, dead);
      if (plan.preW && window.MPCC.norm(w) === window.MPCC.norm(plan.preW) && !dead) preWpill = b;
      b.addEventListener('click', function () {
        setPressed(gW.pills, b);
        gL.pills.innerHTML = '';
        gL.hint.textContent = cfg.hintLengthGo || '';
        lengths.forEach(function (l) {
          var lb = buildPill(l, !avail(w, l));
          var showLenHint = function () {
            var key = String(l).replace(/["']/g, '');
            if (!lb.disabled && lengthHints[key]) gL.hint.textContent = l + ' — ' + lengthHints[key];
          };
          lb.addEventListener('mouseenter', showLenHint);
          lb.addEventListener('focus', showLenHint); /* keyboard parity */
          lb.addEventListener('click', function () {
            if (lb.disabled) return;
            lb.classList.add('is-added');
            var id = variantIdOf(w, l);
            if (id) onCommit({ id: id, handle: p.handle });
          });
          gL.pills.appendChild(lb);
        });
      });
      gW.pills.appendChild(b);
    });
    /* R-24: a cart-resolved waist arrives pre-picked (length row opens
       with honest OOS disabling). Under conflict there is no preW at
       all — the selector opens completely clean (R-25). */
    if (preWpill) preWpill.click();
  }

  function openSelector(tile, quiet) {
    var cfg = config();
    if (!cfg || !window.MPCC || !P.lastCatalog || !tile) return;
    var A = window.MPCC.artifacts;
    var catalog = P.lastCatalog;
    var product = catalog.products[tile.handle];
    if (!product) return;
    closePicker(true);
    var pre = tile.prefill && tile.prefill.mode === 'prefill' ? tile.prefill.attrs : {};

    var plan;
    if (tile.category === 'pants' && tile.tile_mode === 'single-color') {
      /* the approved waist -> length two-step. No preW under conflict
         (R-25); a fully resolved pair never opens this selector at all
         (the tile is instant-add), so only preW can ever be set here —
         auto-clicking it reveals the length row (R-24) without
         auto-committing. */
      plan = { kind: 'pants', category: 'pants', product: product,
               preW: pre.waist || null, rowCount: 2, hasColorRow: false };
    } else {
      var rows = [];
      /* color row opens for ac tiles AND gift selector tiles (M-09:
         the gift's color is the customer's choice) */
      if (tile.tile_mode === 'all-colors' || tile.tile_mode === 'gift-selector') {
        rows.push({ key: 'color', label: cfg.labelColor, kind: 'swatch',
                    values: window.MPCC.attributeValues(tile.category, 'color', catalog, A.adapter),
                    pre: null, hint: cfg.hintColor || '' });
      }
      if (tile.category === 'pants') {
        /* pants all-colors (config-reachable per R-09/A-16): generic
           color + waist + length rows over the whole abstract category */
        rows.push({ key: 'waist', label: cfg.labelWaist, kind: 'pill',
                    values: window.MPCC.attributeValues('pants', 'waist', catalog, A.adapter),
                    pre: pre.waist || null, hint: cfg.hintWaist || '' });
        rows.push({ key: 'length', label: cfg.labelLength, kind: 'pill',
                    values: window.MPCC.attributeValues('pants', 'length', catalog, A.adapter),
                    pre: pre.length || null });
      } else if (tile.category === 'boxer') {
        rows.push({ key: 'length', label: cfg.labelLength, kind: 'pill',
                    values: window.MPCC.attributeValues('boxer', 'length', catalog, A.adapter),
                    pre: pre.length || null });
        rows.push({ key: 'size', label: cfg.labelSize, kind: 'pill',
                    values: window.MPCC.attributeValues('boxer', 'size', catalog, A.adapter),
                    pre: pre.size || null });
      } else {
        rows.push({ key: 'size', label: cfg.labelSize, kind: 'pill',
                    values: window.MPCC.attributeValues('tee', 'size', catalog, A.adapter),
                    pre: pre.size || null });
      }
      var openRows = rows.filter(function (r) { return r.pre == null; }).length;
      var fixedAttrs = {};
      if (tile.tile_mode === 'single-color' && tile.color != null) fixedAttrs.color = tile.color;
      plan = { kind: 'generic', category: tile.category, product: product, rows: rows,
               fixedAttrs: fixedAttrs, rowCount: Math.max(1, openRows),
               giftKind: tile.gift ? tile.giftKind : null,
               hasColorRow: rows.some(function (r) { return r.key === 'color'; }) };
    }

    P.open = true;
    P.tileKey = tileKeyOf(tile);
    P.rowCount = plan.rowCount;
    P.busy = false;
    var surface = surfaceFor(plan.rowCount);
    var onCommit = function (v) { commitAdd(v.id, v.handle || product.handle, !!tile.gift); };
    var contextLine = tile.tile_mode === 'single-color' && tile.color ? tile.color : '';

    if (surface === 'inline') {
      var inline = q('[data-mpcc-inline]');
      if (!inline) return;
      var thumb = inline.querySelector('[data-mpcc-inline-thumb]');
      thumb.innerHTML = tile.image ? '<img src="' + tile.image + '" alt="">' : '';
      inline.querySelector('[data-mpcc-inline-title]').innerHTML = '<span></span><small></small>';
      inline.querySelector('[data-mpcc-inline-title] span').textContent =
        product.title + (contextLine ? ' — ' + contextLine : '');
      inline.querySelector('[data-mpcc-inline-title] small').textContent =
        plan.hasColorRow ? cfg.eyebrowColor : cfg.eyebrowSize;
      var rowsWrap = inline.querySelector('[data-mpcc-inline-rows]');
      rowsWrap.innerHTML = '';
      buildAttrRows(plan, rowsWrap, true, cfg, thumb.querySelector('img'), onCommit);
      inline.hidden = false;
      void inline.offsetHeight;
      inline.classList.add('is-open');
      if (!quiet) {
        var first = rowsWrap.querySelector('button:not(:disabled)');
        if (first) first.focus();
      }
      return;
    }

    var picker = q('[data-mpcc-picker]');
    if (!picker) return;
    picker.querySelector('[data-mpcc-eyebrow]').textContent = plan.hasColorRow ? cfg.eyebrowColor : cfg.eyebrowSize;
    var img = picker.querySelector('[data-mpcc-p-img]');
    if (tile.image) { img.src = tile.image; img.hidden = false; } else { img.hidden = true; }
    picker.querySelector('[data-mpcc-p-title]').textContent = product.title;
    picker.querySelector('[data-mpcc-p-variant]').textContent = contextLine;
    picker.querySelector('[data-mpcc-p-price]').textContent =
      typeof product.price === 'number' ? '$' + (product.price / 100).toFixed(2) : '';
    picker.querySelector('[data-mpcc-p-url]').setAttribute('href', product.url || '#');
    picker.querySelector('[data-mpcc-done]').classList.remove('is-on');
    var rowsHost = picker.querySelector('[data-mpcc-rows]');
    rowsHost.innerHTML = '';
    if (plan.kind === 'pants') {
      buildPantsRows(plan, rowsHost, false, cfg, onCommit);
    } else {
      buildAttrRows(plan, rowsHost, false, cfg, img, onCommit);
    }

    if (surface === 'sheet') {
      var bd = q('[data-mpcc-backdrop]');
      if (bd) bd.hidden = false;
      /* body-part elements with z-index (tier pins/labels) can paint
         above the sheet on some mobile stacking arrangements — hide
         them while the sheet is up */
      var r2 = root();
      if (r2) r2.classList.add('mpcc-sel-open');
    }
    picker.hidden = false;
    placePicker(surface);
    void picker.offsetHeight;
    picker.classList.add('is-open');
    if (surface === 'sheet') {
      var bd2 = q('[data-mpcc-backdrop]');
      if (bd2) bd2.classList.add('is-open');
    }
    if (!quiet) picker.querySelector('.mpcc-picker__close').focus();
  }

  function closePicker(silent) {
    var rc = root();
    if (rc) rc.classList.remove('mpcc-sel-open');
    var picker = q('[data-mpcc-picker]');
    var bd = q('[data-mpcc-backdrop]');
    var inline = q('[data-mpcc-inline]');
    if (picker) {
      picker.classList.remove('is-open');
      setTimeout(function () {
        var cur = q('[data-mpcc-picker]');
        if (cur && !cur.classList.contains('is-open')) { cur.hidden = true; clearPlacement(); }
      }, 330);
    }
    if (bd) { bd.classList.remove('is-open'); setTimeout(function () { var c = q('[data-mpcc-backdrop]'); if (c && !c.classList.contains('is-open')) c.hidden = true; }, 260); }
    if (inline) { inline.classList.remove('is-open'); }
    if (!silent && P.tileKey && P.lastResult) {
      for (var i = 0; i < P.lastResult.tiles.length; i++) {
        if (tileKeyOf(P.lastResult.tiles[i]) === P.tileKey) {
          var trigger = q('[data-mpcc-tile="' + i + '"]');
          if (trigger) trigger.focus();
          break;
        }
      }
    }
    P.open = false;
    P.tileKey = null;
    P.rowCount = 0;
  }

  /* tile taps + close triggers (delegated). R-27: one target, one
     action — instant-add tiles add, selector tiles open the selector. */
  document.addEventListener('click', function (e) {
    var r = root();
    if (!r) return;
    var tileEl = e.target.closest('[data-mpcc-tile]');
    if (tileEl && r.contains(tileEl)) {
      e.preventDefault();
      var idx = parseInt(tileEl.getAttribute('data-mpcc-tile'), 10);
      var tile = P.lastResult && P.lastResult.tiles[idx];
      if (!tile) return;
      if (tile.state === 'instant-add') instantAdd(tile, tileEl);
      else openSelector(tile);
      return;
    }
    var closer = e.target.closest('[data-mpcc-close]');
    if (closer && r.contains(closer)) {
      e.preventDefault();
      closePicker();
    }
  });

  /* Esc closes the picker BEFORE the theme focus trap closes the drawer */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && P.open) {
      e.stopImmediatePropagation();
      e.preventDefault();
      closePicker();
    }
  }, true);

  /* crossing the breakpoint closes the picker (surface would change) */
  window.matchMedia('(min-width: 990px)').addEventListener('change', function () {
    if (P.open) closePicker(true);
  });

  /* after every drawer re-render (R-28 rail): recompute + re-render the
     widget from the fresh islands, then pending toast / mid-flight
     selector reopen / toast keep-alive */
  document.addEventListener('cart-drawer:refreshed', function () {
    /* theme.js's emptied-cart re-render path (replaceContent with
       item_count 0) centers the body slot (drawer--center-body) and
       fades the footer part out WITHOUT ever restoring it — the stock
       section renders no footer when empty, ours always does (R-29:
       the widget + checkout render on the 000 row). Undo both. */
    var r0 = root();
    if (r0) {
      r0.classList.remove('drawer--center-body');
      var fp = r0.shadowRoot && r0.shadowRoot.querySelector('[part~="footer"]');
      if (fp) {
        var wasFaded = fp.style.opacity === '0';
        fp.style.opacity = '';
        fp.style.transform = '';
        /* rejoin the theme's emptied-cart fade: restore the footer with
           the same curve it uses for the body, so the transition reads
           as one coherent fade instead of a pop */
        if (wasFaded && fp.animate && !window.__mpccHarness &&
            !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          fp.animate(
            { opacity: [0, 1], transform: ['translateY(30px)', 'translateY(0)'] },
            { duration: 250, easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)' }
          );
        }
      }
    }
    availPatch = {}; /* fresh server islands supersede L-03 patches */
    renderWidget();
    enforceGiftEligibility(); /* M-07.4 loss guard */
    clearTimeout(busyWatchdog);
    var addJustLanded = P.busy && !P.commitPending;
    /* an instant add resolves here: the server re-render IS the
       confirmation (R-26) — no toast */
    if (addJustLanded) P.busy = false;
    if (P.commitPending) {
      /* a selector commit landed: close the picker state, no toast */
      P.commitPending = false;
      P.busy = false;
      closePicker(true);
    } else if (P.open && !P.busy && P.tileKey) {
      /* mid-flight re-render (e.g. ghost sync): reopen the selector for
         the same tile if it still exists in selector state — quietly,
         without stealing focus from whatever the user is doing */
      var match = null;
      var tiles = P.lastResult ? P.lastResult.tiles : [];
      for (var i = 0; i < tiles.length; i++) {
        if (tileKeyOf(tiles[i]) === P.tileKey && tiles[i].state === 'selector') { match = tiles[i]; break; }
      }
      if (match) openSelector(match, true); else closePicker(true);
    }
    /* the tapped tile was destroyed with the old DOM: if focus fell to
       <body>, land it on the first tile so keyboard flow continues */
    if (addJustLanded && document.activeElement === document.body) {
      var firstTile = q('[data-mpcc-tile]');
      if (firstTile) firstTile.focus();
    }
    if (toastKeep.msg && Date.now() < toastKeep.until) {
      var t = q('[data-mpcc-toast]');
      if (t) { t.textContent = toastKeep.msg; t.classList.add('is-on'); }
    }
    bindStrip();
  });
  /* theme editor: section re-injected without a cart change (fresh
     strip node needs its listeners again) */
  document.addEventListener('shopify:section:load', function () { renderWidget(); bindStrip(); });

  /* ---------- strip: wheel + drag scroll (desktop nicety) ---------- */
  function bindStrip() {
    var el = q('[data-mpcc-strip]');
    if (!el || el._mpccBound) return;
    el._mpccBound = true;
    el.addEventListener('scroll', function () { lastStripScroll = el.scrollLeft; }, { passive: true });
    el.addEventListener('dragstart', function (e) {
      if (e.target.closest('.mpcc-card__img')) e.preventDefault();
    }, true);
    /* a drag that scrolled the strip must NOT fire the tile under the
       pointer — preventDefault on mouseup does not cancel the click
       event, so swallow it in capture phase */
    var dragMoved = false;
    el.addEventListener('click', function (ev) {
      if (dragMoved) {
        dragMoved = false;
        ev.stopPropagation();
        ev.preventDefault();
      }
    }, true);
    /* programmatic scrollLeft fights mandatory scroll-snap: lift the snap
       while wheel/drag drive the strip, re-snap shortly after they stop */
    var snapT = null;
    var suspendSnap = function () {
      el.classList.add('is-dragging');
      clearTimeout(snapT);
      snapT = setTimeout(function () { el.classList.remove('is-dragging'); }, 150);
    };
    el.addEventListener('wheel', function (e) {
      if (e.shiftKey || Math.abs(e.deltaX) > Math.abs(e.deltaY) || el.scrollWidth <= el.clientWidth) return;
      if (e.deltaMode === WheelEvent.DOM_DELTA_PIXEL && Math.abs(e.deltaY) < 40) return;
      e.preventDefault();
      suspendSnap();
      el.scrollLeft += e.deltaY;
    }, { passive: false });
    var drag = null;
    var onMove = function (e) {
      if (!drag) return;
      e.preventDefault();
      if (Math.abs(e.clientX - drag.x) > 5) dragMoved = true;
      suspendSnap();
      el.scrollLeft = drag.left - (e.clientX - drag.x);
    };
    el.addEventListener('mousedown', function (e) {
      if (e.button !== 0 || el.scrollWidth <= el.clientWidth) return;
      drag = { left: el.scrollLeft, x: e.clientX };
      dragMoved = false;
      suspendSnap();
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', function (ev) {
        document.removeEventListener('mousemove', onMove);
        if (drag && ev.clientX - drag.x !== 0) ev.preventDefault();
        drag = null;
        /* the browser dispatches the click synchronously after mouseup;
           this queued reset runs after it, so a drag ending off-strip
           can never swallow a later genuine click */
        setTimeout(function () { dragMoved = false; }, 0);
      }, { once: true });
    });
  }

  function init() { mountPickerForm(); renderWidget(); enforceGiftEligibility(); bindStrip(); scheduleGhost(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mpcc-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const VBH = 40.13;
  const PERIOD = 158.97;
  const START = -6.528;
  const WIN = [
    [-6.528, 26.41],
    [19.883, 26.562],
    [46.445, 26.47],
    [72.915, 26.58],
    [99.495, 26.443],
    [125.938, 26.505]
  ];

  class MpccHeader extends HTMLElement {
    connectedCallback() {
      this.stream = this.querySelector('[data-mpcc-stream]');
      this.logoSvg = this.querySelector('[data-mpcc-logo-svg]');
      this.band = this.querySelector('.mpcc-header__band');
      this.islands = Array.from(this.querySelectorAll('[data-mpcc-island]'));
      if (!this.stream || !this.logoSvg) return;
      this.clearance = parseFloat(this.dataset.clearance || '16');
      this._raf = 0;
      this._ro = new ResizeObserver(() => this.schedule());
      this._ro.observe(this.stream);
      if (this.band) this._ro.observe(this.band);
      this.islands.forEach((el) => this._ro.observe(el));
      this.layout();
    }
    disconnectedCallback() {
      if (this._ro) this._ro.disconnect();
      cancelAnimationFrame(this._raf);
    }
    schedule() {
      cancelAnimationFrame(this._raf);
      this._raf = requestAnimationFrame(() => this.layout());
    }
    layout() {
      if (this.band) {
        const bandH = this.band.getBoundingClientRect().height;
        if (bandH) {
          document.documentElement.style.setProperty('--header-height', bandH.toFixed(2) + 'px');
        }
      }
      const stream = this.stream;
      if (getComputedStyle(stream).display === 'none') {
        stream.innerHTML = '';
        return;
      }
      const band = stream.getBoundingClientRect();
      const logo = this.logoSvg.getBoundingClientRect();
      if (!band.width || !logo.height) {
        stream.innerHTML = '';
        return;
      }
      const scale = logo.height / VBH;
      const anchor = logo.left - band.left;
      const top = logo.top - band.top;
      const unitH = logo.height;
      const c = this.clearance;
      const blocks = this.islands
        .map((el) => el.getBoundingClientRect())
        .filter((r) => r.width > 0 && r.height > 0)
        .map((r) => [r.left - band.left - c, r.right - band.left + c]);
      const pw = PERIOD * scale;
      const sym = this.dataset.symbol;
      let html = '';
      for (let r = Math.floor(-anchor / pw) - 1; anchor + r * pw < band.width; r++) {
        if (r === 0) continue;
        for (let k = 0; k < 6; k++) {
          const x = anchor + r * pw + (WIN[k][0] - START) * scale;
          const w = WIN[k][1] * scale;
          if (x < 0 || x + w > band.width) continue;
          if (blocks.some((b) => x < b[1] && x + w > b[0])) continue;
          html +=
            '<svg class="mpcc-header__unit" style="left:' + x.toFixed(2) +
            'px;top:' + top.toFixed(2) + 'px;width:' + w.toFixed(2) +
            'px;height:' + unitH.toFixed(2) + 'px" viewBox="' + WIN[k][0] +
            ' 0 ' + WIN[k][1] + ' ' + VBH +
            '" aria-hidden="true" focusable="false"><use href="#' + sym + '"/></svg>';
        }
      }
      stream.innerHTML = html;
    }
  }

  if (!customElements.get('mpcc-header')) {
    customElements.define('mpcc-header', MpccHeader);
  }

  /* cart badge: live update on cart changes, excluding the drawer's ghost
     line (variant id stamped on the cart link when the setting is set) */
  document.addEventListener('cart:change', function (e) {
    var cart = e.detail && e.detail.cart;
    if (!cart || !cart.items) return;
    document.querySelectorAll('[data-mpcc-count]').forEach(function (badge) {
      var link = badge.closest('a');
      var ghostId = link ? link.getAttribute('data-mpcc-ghost-variant') : null;
      var n = 0;
      cart.items.forEach(function (item) {
        if (ghostId && String(item.variant_id) === ghostId) return;
        n += item.quantity;
      });
      badge.textContent = n;
      badge.hidden = n === 0;
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
